import type { I18nTranslations } from './i18n-en';

const i18n_gr: I18nTranslations = {
  close_btn: 'Κλείσιμο',
  search_placeholder: 'Αναζήτηση',
  loading: 'Φόρτωση',

  label_inactive: 'Ανενεργό',
  label_invalid: 'Άκυρο',

  active_devices: 'Συσκευές {{devices_len}} ενεργές',
  change_language: 'Αλλαγή γλώσσας',
  language_changed_message: 'Η γλώσσα άλλαξε',

  error_select_device_message: 'Επιλέξτε πρώτα συσκευή',
  select_device: 'Επιλέξτε συσκευή',
  select_company_menu_message: 'Επιλέξτε εταιρεία για προβολή της λίστας συσκευών',
  select_company_required_header: 'Επιλέξτε μια εταιρεία για να προχωρήσετε',
  select_company_required_from: 'Από εδώ: ',
  select_company_required_accounts_page_link: 'Σελίδα Λογαριασμών',

  second: 'δευτερόλεπτο',
  seconds: 'δευτερόλεπτα',
  second_one: 'δευτερόλεπτο',
  second_other: 'δευτερόλεπτα',
  minute: 'λεπτό',
  minutes: 'λεπτά',
  minute_one: 'λεπτό',
  minute_other: 'λεπτά',
  hour: 'ώρα',
  hours: 'ώρες',
  hour_one: 'ώρα',
  hour_other: 'ώρες',
  day: 'ημέρα',
  day_one: 'ημέρα',
  day_other: 'μέρες',
  start_date: 'Ημερομηνία έναρξης',
  end_date: 'Ημερομηνία λήξης',
  from_date: 'Από',
  to_date: 'Μέχρι',
  avg_from_date: 'Μέσος όρος Από Ημερομηνία',
  avg_to_date: 'Μέσος όρος Μέχρι σήμερα',
  period: 'Περίοδος',
  description: 'Περιγραφή',
  date: 'Ημερομηνία',
  number: 'Αριθμός',
  apply: 'Εφαρμογή',
  update: 'Ενημέρωση',
  create: 'Δημιουργία',
  delete: 'Διαγραφή',
  export: 'Εξαγωγή',
  rssi: 'rssi',
  ber: 'ber',
  reading: 'Μέτρηση',
  model: 'Μοντέλο',
  email_address: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου',
  password: 'Κωδικός πρόσβασης',
  confirm_password: 'Επιβεβαίωση Κωδικού',
  sign_in: 'Συνδεθείτε',
  graph: 'Γράφημα',
  no_data: 'Χωρίς δεδομένα',
  every: 'Kάθε',
  for_company: 'Για παρεα',
  flow: 'Ροή',
  no_data_found: 'Δε βρέθηκαν δεδομένα.',
  percent: 'Τοις εκατό',
  device_number_devicenum: 'Αριθμός συσκευής: {{device_number}}',
  device_number: 'Αριθμός συσκευής',
  device_name: 'Όνομα συσκευής',
  successfully_saved: 'Αποθηκεύτηκε με επιτυχία',
  error_occured: 'Παρουσιάστηκε σφάλμα',
  none: 'Κανένα',
  off: 'Απενεργοποιημένο',
  no_unit: 'Καμία μονάδα μέτρησης',
  hardware_version: 'Έκδοση Υλικού',
  software_version: 'Έκδοση Λογισμικού',
  transmission_period: 'Περίοδος Μετάδοσης',
  record_period: 'Περίοδος Εγγραφής',
  replacement_number: 'Αριθμός αντικατάστασης',
  replaced_by: 'Αντικαταστάθηκε από',

  createdOn: 'Δημιουργήθηκε στις',
  createdBy: 'Δημιουργήθηκε από',

  show_average: 'Εμφάνιση μέσου όρου',
  show_readings: 'Εμφάνιση αναγνώσεων',

  yes: 'Ναί',
  no: 'Οχι',
  capital_yes: 'ΝΑΙ',
  capital_no: 'ΟΧΙ',

  sensor: 'Αισθητήρας',

  all_sensors: 'Όλοι οι αισθητήρες',

  select_all: 'Επιλογή όλων',
  deselect_all: 'Αποεπιλογή όλων',

  function_last: 'Last',
  function_first: 'First',
  function_avg: 'Average',
  function_min: 'Min',
  function_max: 'Max',
  function_median: 'Median',
  function_count: 'Count',
  function_last_flow: 'Last Flow',
  function_first_flow: 'First Flow',
  function_avg_flow: 'Average Flow',
  function_max_flow: 'Max Flow',
  function_min_flow: 'Min Flow',
  function_median_flow: 'Median Flow',

  page_title_header_number_with_name_absent: '{{title}} - {{device_number}}',
  page_title_header_number_with_name_present: '{{title}} - {{device_name}} ({{device_number}})',

  error_forbidden_operation_not_allowed: 'Μη επιτρεπόμενο',

  not_set: 'Δεν έχει οριστεί',

  //Sensor Types
  generic_analog_sensor: 'Γενικός αναλογικός αισθητήρας',
  generic_virtual_sensor: 'Γενικός εικονικός αισθητήρας',
  generic_digital_sensor: 'Γενικός Ψηφιακός Αισθητήρας',
  modbus_generic_analog_sensor: 'Γενικός Αναλογικός Αισθητήρας Modbus',
  modbus_generic_digital_sensor: 'Γενικός Ψηφιακός Αισθητήρας Modbus',
  pressure_sensor: 'Αισθητήρας πίεσης',
  temperature_sensor: 'Αισθητήρας θερμοκρασίας',
  humidity_sensor: 'Αισθητήρας υγρασίας',
  level_sensor: 'Αισθητήρας επιπέδου',
  weight_meter: 'Μέτρο βάρους',
  weight_sensor: 'Αισθητήρας βάρους',
  load_cells: 'Κελιά φορτίου',
  wind_direction_sensor: 'Αισθητήρας διεύθυνσης ανέμου',
  barometric_pressure_sensor: 'Αισθητήρας βαρομετρικής πίεσης',
  soil_moisture_sensor: 'Αισθητήρας υγρασίας εδάφους',
  dew_point_sensor: 'Αισθητήρας σημείου δρόσου',
  soil_temperature_sensor: 'Αισθητήρας θερμοκρασίας εδάφους',
  soil_potential_sensor: 'Αισθητήρας δυναμικού εδάφους',
  particulate_matter_sensor: 'Αισθητήρας σωματιδίων',
  leaf_wetness_sensor: 'Αισθητήρας υγρασίας φύλλων',
  gnss_sensor: 'Αισθητήρας GNSS',
  water_meter: 'Υδρόμετρο',
  power_meter: 'Μετρητής ισχύος',
  gas_flow_meter: 'Μετρητής ροής αερίου',
  rain_sensor: 'Αισθητήρας βροχής',
  wind_speed_sensor: 'Αισθητήρας ταχύτητας ανέμου',
  heat_meter: 'Μετρητής θερμότητας',
  geiger_mueller_counter: 'Μετρητής Geiger-Mueller',
  on_off_sensor: 'Αισθητήρας Ενεργοποίησης/Απενεργοποίησης',
  on_off_input_sensor: 'Αισθητήρας Εισόδου Ενεργοποίησης/Απενεργοποίησης',
  on_off_output_sensor: 'Αισθητήρας Εξόδου Ενεργοποίησης/Απενεργοποίησης',
  on_off_auto_output_sensor: 'Αισθητήρας Εξόδου Ενεργοποίησης/Απενεργοποίησης/Αυτόματου',
  tasmota_relay_sensor: 'Αισθητήρας Ρελέ Tasmota',
  modbus_generic_on_off_input_sensor:
    'Γενικός Αισθητήρας Εισόδου Ενεργοποίησης/Απενεργοποίησης Modbus',
  modbus_generic_on_off_output_sensor:
    'Γενικός Αισθητήρας Εξόδου Ενεργοποίησης/Απενεργοποίησης Modbus',
  co_sensor: 'Αισθητήρας CO',
  no2_sensor: 'Αισθητήρας NO2',
  so2_sensor: 'Αισθητήρας SO2',

  // Port Types
  digital_input_port: 'Ψηφιακή Θύρα Εισόδου',
  pulse_input_port: 'Θύρα Εισόδου Παλμού',
  pulse_s0_input_port: 'Θύρα Εισόδου Παλμού S0',
  analog_input_port: 'Αναλογική Θύρα Εισόδου',
  '4_20_mA_input_port': 'Θύρα Εισόδου 4-20mA',
  '0_5_V_input_port': 'Θύρα Εισόδου 0-5V',
  on_off_input_port: 'Θύρα Εισόδου On/Off',
  on_off_output_port: 'Θύρα Εξόδου On/Off',
  generic_modbus_on_off_input_port: 'Γενική Θύρα Εισόδου On/Off Modbus',
  generic_modbus_on_off_output_port: 'Γενική Θύρα Εξόδου On/Off Modbus',

  // duration
  duration_years_one: '{{count}} έτος',
  duration_years_other: '{{count}} έτη',
  duration_months_one: '{{count}} μήνας',
  duration_months_other: '{{count}} μήνες',
  duration_months_abbr: 'μήν.',
  duration_days_one: '{{count}} ημέρα',
  duration_days_other: '{{count}} ημέρες',
  duration_hours_one: '{{count}} ώρα',
  duration_hours_other: '{{count}} ώρες',
  duration_minutes_one: '{{count}} λεπτό',
  duration_minutes_other: '{{count}} λεπτά',
  duration_seconds_one: '{{count}} δευτερόλεπτο',
  duration_seconds_other: '{{count}} δευτερόλεπτα',

  years: 'Έτη',
  months: 'Μήνες',
  days: 'Ημέρες',

  /*
   * |===============|
   * | Period Picker |
   * |===============|
   */
  period_date_range: 'Εύρος ημερομηνιών',
  period_custom: 'Εθιμο',
  period_today: 'Σήμερα',
  period_week: 'Εβδομάδα',
  period_month: 'Μήνας',
  period_yesterday: 'Εχθές',
  period_last_week: 'Την προηγούμενη εβδομάδα',
  period_last_month: 'Τον προηγούμενο μήνα',
  period_last_1_hours: 'Τελευταία ώρα',
  period_last_2_hours: 'Τελευταίες 2 ώρες',
  period_last_4_hours: 'Τελευταίες 4 ώρες',
  period_last_24_hours: 'Τελευταίες 24 ώρες',
  period_last_48_hours: 'Τελευταίες 48 ώρες',

  /*
   * |=====================|
   * | Hook Error Messages |
   * |=====================|
   */
  error_cannot_fetch_device: 'Δεν ήταν δυνατή η ανάκτηση της συσκευής.',
  error_cannot_fetch_device_config: 'Δεν ήταν δυνατή η ανάκτηση των παραμέτρων της συσκευής.',
  error_cannot_fetch_ports_config: 'Δεν ήταν δυνατή η ανάκτηση των παραμέτρων των θυρών.',
  error_cannot_fetch_flow_stats: 'Δεν ήταν δυνατή η ανάκτηση στατιστικών στοιχείων ροής.',
  error_cannot_fetch_time_stats: 'Δεν ήταν δυνατή η ανάκτηση στατιστικών χρόνου.',
  error_cannot_fetch_general_stats: 'Δεν ήταν δυνατή η ανάκτηση γενικών στατιστικών.',
  error_cannot_fetch_qflow_stats: 'Δεν ήταν δυνατή η λήψη στατιστικών στοιχείων qflow.',

  signup_company_name: 'Όνομα Εταιρείας',

  sign_up_form_first_name: 'Ονομα',
  sign_up_form_last_name: 'Επίθετο',
  sign_up_form_email: 'Διεύθυνση Ηλεκτρονικού Ταχυδρομείου',
  sign_up_form_password: 'Κωδικός Πρόσβασης',
  sign_up_form_confirm_password: 'Επιβεβαίωση Κωδικού',
  sign_up_form_company_name: 'Όνομα Εταιρείας',

  button_save: 'Αποθήκευση',
  button_apply: 'Εφαρμογή',
  button_update: 'Ενημέρωση',
  button_create: 'Δημιουργία',
  button_delete: 'Διαγραφή',
  button_continue: 'Συνέχεια',
  button_back: 'Πίσω',
  dashboard_tour_back: 'Πίσω',
  dashboard_tour_next: 'Επόμενο',
  dashboard_tour_finish: 'Ολοκλήρωση',
  dashboard_tour_close: 'Κλείσιμο',
  dashboard_tour_open: 'Άνοιγμα διαλόγου',
  dashboard_tour_skip: 'Παράλειψη',
  dashboard_tour_next_with_progress: 'Επόμενο ({current} από {total})',
  capital_add_btn: 'ΠΡΟΣΘΗΚΗ',
  capital_create_btn: 'ΔΗΜΙΟΥΡΓΩ',
  capital_update_btn: 'ΕΚΣΥΓΧΡΟΝΙΖΩ',
  capital_remove_btn: 'ΑΦΑΙΡΩ',
  capital_cancel_btn: 'ΜΑΤΑΙΩΣΗ',

  role_roles: 'Ρόλοι',
  role_user: 'Χρήστης',
  role_public: 'Δημόσιο',
  role_admin: 'διαχειριστής',
  role_billing: 'Τιμολόγηση',
  role_super_admin: 'Σούπερ Διαχειριστής',
  role_restricted: 'Περιορισμένος',

  device_counters_cumulative_graph_graph: 'Γράφημα, αριθμός συσκευής: {{device_number}}',
  device_counters_cumulative_graph_must_have_analog_sensor:
    'Πρέπει να έχετε ενεργοποιημένο αναλογικό αισθητήρα.',

  sensor_statistics_min: 'Ελάχιστη: {{min}}',
  sensor_statistics_max: 'Μέγιστη: {{max}}',
  sensor_statistics_avg: 'Μέσος όρος: {{avrg}}',
  sensor_statistics_total: 'Σύνολο: {{total}}',

  chart_statistics_min: 'Ελάχιστη:',
  chart_statistics_max: 'Μέγιστη:',
  chart_statistics_avg: 'Μέσος όρος:',
  chart_statistics_total: 'Σύνολο:',

  menu_main: 'Κύριος',
  menu_device: 'Συσκευή',

  submenu_devices: 'συσκευές',
  submenu_account: 'λογαριασμός',
  submenu_device_reports: 'Αναφορές συσκευής',
  submenu_settings: 'Ρυθμίσεις',

  link_selected_device: 'Επιλεγμένη Συσκευή',
  link_device_nodes: 'Κόμβοι Συσκευών',
  link_devices: 'Λίστα συσκευών',
  link_accounts: 'Λογαριασμοί',
  link_utility_rate: 'Τιμές χρέωσης',
  link_link_device: 'Σύνδεση Συσκευής',
  link_create_user: 'Δημιουργία Χρήστη',
  link_icons: 'Εικονίδια',
  link_licenses: 'Άδειες',
  link_accounts_manager: 'Διαχείριση Λογαριασμών',
  link_transmissions: 'Μεταδόσεις',
  link_map: 'Χάρτης',
  link_inventory: 'Απόθεμα',
  link_devices_manager: 'Διαχειριση Συσκευών',
  link_battery: 'Μπαταρία',
  device_groups: 'Ομάδες συσκευών',
  link_signal: 'Σήμα',
  link_alarms: 'Συναγερμοί',
  link_value_ranges: 'Συμβάντα εύρους τιμών',
  link_device_account_lookup: 'Αναζήτηση λογαριασμού συσκευής',
  link_show_users: 'Χρήστες',
  link_dashboard: 'Ταμπλό',
  link_dashboard_2: 'Ταμπλό 2',
  link_reports: 'Εκθέσεις',
  link_scheduled_reports: 'Προγραμματισμένες Εκθέσεις',
  link_billing_report: 'Αναφορά χρέωσης',

  link_all_devices: 'Όλες οι συσκευές',
  link_readings: 'Μετρήσεις',
  link_sensors_data: 'Δεδομένα αισθητήρων',
  link_flow: 'Ροή',
  link_graph: 'Γράφημα',
  link_new_graph: 'Στιγμιαίο γράφημα',
  link_pump_control: 'Pump Control',
  link_relay_control: 'Relay Control',
  link_alarm_config: 'Διαμόρφωση Συναγερμών',
  link_statistics: 'Στατιστικά',
  link_customer: 'Πελάτης',
  link_meter: 'Υδρομετρο',
  link_config: 'Συγχρονισμός ρυθμίσεων',
  link_initial_config: 'Αρχική Διαμόρφωση (παλαιά)',
  link_sensor_config: 'Διαμορφωση Αισθητήρα (παλαιά)',
  link_sensors_and_network_config: 'Διαμόρφωση παραμέτρων',
  link_export: 'Εξαγωγή',
  link_customer_billing_report: 'Αναφορά χρέωσης πελατών',
  link_flow_generator: 'Γεννήτρια ροής',
  link_commands: 'Εντολές',
  link_copy_config: 'Αντιγραφή διαμόρφωσης',
  switch_to_new_menu_label: 'Χρησιμοποιήστε το νέο μενού',
  switch_to_old_menu_label: 'Χρησιμοποιήστε το παλιό μενού',
  link_profile: 'Προφίλ',
  link_language: 'Γλώσσα',
  link_sign_out: 'Εξοδος',

  chip_early_access: 'Πρόωρη Πρόσβαση',

  pulse_sensor_1: 'Αισθητήρας Παλμού 1',
  pulse_sensor_2: 'Αισθητήρας Παλμού 2',
  analog_sensor_1: 'Αναλογικός Αισθητήρας 1',
  analog_sensor_2: 'Αναλογικός Αισθητήρας 2',
  analog_sensor_3: 'Αναλογικός Αισθητήρας 3',
  analog_sensor_4: 'Αναλογικός Αισθητήρας 4',
  analog_sensor_5: 'Αισθητήρας 1',
  analog_sensor_6: 'Αισθητήρας 2',
  analog_sensor_7: 'Αισθητήρας 3',
  analog_sensor_8: 'Αισθητήρας 4',
  on_off_sensor_1: 'Αισθητήρας ενεργοποίηση/απενεργοποίηση 1',
  on_off_sensor_2: 'Αισθητήρας ενεργοποίηση/απενεργοποίηση 2',
  on_off_sensor_3: 'Ρελέ ενεργοποίηση/απενεργοποίηση 1',
  on_off_sensor_4: 'Ρελέ ενεργοποίηση/απενεργοποίηση 2',

  device_icon: 'Εικονίδιο συσκευής',
  sensor_icon: 'Εικονίδιο αισθητήρα',
  icon_no_icon: 'Κανένα εικονίδιο',
  icon_barometer: 'Βαρόμετρο',
  icon_door_closed: 'Πόρτα Κλειστή',
  icon_door_open: 'Πόρτα Ανοιχτή',
  icon_electricity: 'Ηλεκτρική ενέργεια',
  icon_energy_meter: 'Μετρητής ενέργειας',
  icon_gas_flow_meter: 'Μετρητής ροής αερίου',
  icon_gas: 'Αέριο',
  icon_generic_particle_meter: 'Γενικός μετρητής σωματιδίων',
  icon_generic: 'Γενικός',
  icon_heat_meter: 'Μετρητής θερμότητας',
  icon_humidity: 'Υγρασία',
  icon_leaf_moisture: 'Υγρασία φύλλων',
  icon_level_metering: 'Μέτρηση στάθμης',
  icon_pivot: 'Αξονας περιστροφής',
  icon_pressure: 'Πίεση',
  icon_radiation: 'Ακτινοβολία',
  icon_rain: 'Βροχή',
  icon_soil_moisture: 'Υγρασία εδάφους',
  icon_temperature: 'Θερμοκρασία',
  icon_water_meter: 'Υδρόμετρο',
  icon_water: 'Νερό',
  icon_wind_direction: 'Κατεύθυνση ανέμου',
  icon_wind_speed: 'Ταχυτητα Ανεμου',
  icon_pump: 'Αντλία',
  icon_apartment: 'Κτίριο Διαμερισμάτων',
  icon_base_station: 'Βάση Σταθμού',
  icon_clinic: 'Κλινική',
  icon_hospital: 'Νοσοκομείο',
  icon_house: 'Σπίτι',
  icon_mayor_office: 'Κτίριο Γραφείου Δημάρχου',
  icon_police_station: 'Τμήμα Αστυνομίας',
  icon_public_restroom: 'Δημόσια Τουαλέτα',
  icon_stadium: 'Στάδιο',
  icon_gas_station: 'Πρατήριο καυσίμων',
  icon_controller: 'Ελεγκτής',

  device_icon_new_portal: 'Εικονίδιο (νέα πύλη)',
  device_icon_old_portal: 'Εικονίδιο (παλιά πύλη)',

  very_low_level_alarm: 'Συναγερμός πολύ χαμηλής στάθμης',
  low_level_alarm: 'Συναγερμός χαμηλής στάθμης',
  high_level_alarm: 'Συναγερμός υψηλής στάθμης',
  very_high_level_alarm: 'Συναγερμός πολύ υψηλού επιπέδου',

  sensor_conversion_formula: 'Τύπος μετατροπής αισθητήρα',
  delete_old_counters: 'Διαγραφή παλαιών αναφορών',
  device_config_select_record_period: 'Επιλέξτε περίοδο εγγραφής',
  device_config_select_transmission_period: 'Επιλέξτε περίοδο μετάδοσης',

  devices_table_number: 'Αριθμός',
  devices_table_name: 'Όνομα',
  devices_table_device_number: 'Αριθμός συσκευής',
  devices_table_device_name: 'Όνομα συσκευής',
  devices_table_business_partner: 'Επιχειρηματικός εταίρος',
  devices_table_quarter: 'Τρίμηνο',
  devices_table_address: 'Διεύθυνση',
  devices_table_error: 'Δεν ήταν δυνατή η φόρτωση συσκευών',
  devices_table_no_devices_found: 'Δεν βρέθηκαν συσκευές',
  devices_table_description: 'Περιγραφή',
  devices_column_header_search: 'Αναζήτηση...',

  alarm_config_header: 'Διαμόρφωση συναγερμών',
  alarm_config_notification_email: 'Εμαιλ ειδοποιήσης',
  alarm_config_notification_email_place_holder: 'Λίστα Email (διαχωρισμός με κόμμα)',
  alarm_config_missed_transmission_email: 'Χαμένα μηνύματα ηλεκτρονικού ταχυδρομείου μετάδοσης',
  alarm_config_missed_transmission_email_place_holder:
    'Λίστα email αναπάντητων μεταδόσεων (χωρισμένο με κόμμα)',
  alarm_config_high_consumption_threshold:
    'Όριο υψηλής κατανάλωσης για την περίοδο μετάδοσης {{transmision_evey}} {{transmision_period}} [{{units}}]',
  alarm_config_low_flow_alarm_threshold: 'Όριο συναγερμού χαμηλής ροής  [{{units}}]',
  alarm_config_high_flow_alarm_threshold: 'Όριο συναγερμού υψηλής ροής [{{units}}]',
  alarm_config_non_zero_consumption_time_range: 'Χρονικό εύρος μη μηδενικής κατανάλωσης',
  alarm_config_high_low_flow_time_range: 'Χρονικό διάστημα για μεγάλη/μικρή ροή',
  alarm_config_start_time: 'Ώρα έναρξης',
  alarm_config_end_time: 'Ώρα λήξης',
  alarm_config_flow_calc_time_base: 'Βάση υπολογισμού ροής',
  alarm_config_saved_msg: 'Η διαμόρφωση συναγερμών σώθηκε.',
  alarm_config_email_validation_error:
    'Παρακαλώ εισάγετε έγκυρες διευθύνσεις email, χωρισμένες με μία μόνο κόμμα και χωρίς κενό, με μέγιστο μήκος 255 χαρακτήρων.',

  alarm_config_non_zero_consumption_time_range_error:
    'Πρέπει να υπάρχει χρόνος έναρξης και χρόνος λήξης',
  alarm_config_low_flow_severity: 'Σοβαρότητα χαμηλής ροής',
  alarm_config_high_flow_severity: 'Σοβαρότητα υψηλής ροής',
  alarm_config_high_consumption_severity: 'Σοβαρότητα υψηλής κατανάλωσης',
  alarm_config_all_zero_severity: 'Σοβαρότητα μηδενικής κατανάλωσης',
  alarm_config_non_zero_consumption_severity: 'Σοβαρότητα μη μηδενικής κατανάλωσης',
  alarm_config_on_off_severity: 'Σοβαρότητα ενεργοποίησης/απενεργοποίησης',

  alarms_title: 'Συναγερμοί',
  alarms_title_with_dev_num: 'Συναγερμός, αριθμός συσκευής: {{device_number}}',
  alarms_type: 'Τύπος συναγερμού',
  alarms_active_status: 'Δραστηριότητα',
  alarms_active_dropdown_label: 'Ενεργός',
  alarms_inactive_dropdown_label: 'Αδρανής',

  device_battery_title: 'Επίπεδο μπαταρίας',
  device_battery_voltage: 'Τάση, mV',
  device_battery_level: 'Επίπεδο, %',

  device_signal_title: 'Ισχύς σήματος',

  device_counters_graph_header: 'Γράφημα Κατανάλωσης',

  device_instant_graph_header: 'Στιγμιαίο γράφημα',

  devices_signal_title: 'Σήμα συσκευής',
  devices_signal_level: 'Επίπεδο σήματος',
  devices_signal_level_percent: 'Επίπεδο, %',

  devices_battery_title: 'Επίπεδο μπαταρίων',
  devices_battery_level: 'Επίπεδο μπαταριας, %',
  devices_battery_voltage: 'Τάση, mV',

  reports_export_title: 'Εξαγωγή εκθέσεων σε αρχείο',

  device_counter_export_title:
    'Εξαγωγή μετρητών (counters) συσκευής, device number: {{device_number}}',

  device_config_record_and_transmission_period: 'Περίοδοι εγγραφής και μετάδοσης',
  device_config_record_period: 'Περίοδος Εγγραφής',
  device_config_transmission_period: 'Περίοδος Μετάδοσης',
  device_config_start_setup: 'Έναρξη Διαμόρφωσης',
  device_config_setup_message:
    'Η διαμόρφωση αποθηκεύτηκε. Τώρα τοποθετήστε ένα μαγνήτη στη συσκευή σας.',
  device_config_header: 'Διαμόρφωση συσκευής',
  device_config_config_date: 'Ημερομηνία διαμόρφωσης: {{date}}',
  device_config_config_status: 'Κατάσταση',
  device_config_config_status_configured: 'Συγχρονισμένο',
  device_config_config_status_not_configured: 'Μη συγχρονισμένο',
  device_config_time_zone: 'Ζώνη ώρας',
  device_config_pulse_per: '{{x}} ανά пαλμοί',
  device_config_sensor_type: 'Τύπος αισθητήρα',
  device_config_meter_type: 'Τύπος μετρητή',
  device_config_select_time_zone: 'Επιλέξτε ζώνη ώρας',
  device_config_missed_transmission_alarm_severity: 'Βαρύτητα συναγερμού για χαμένη μετάδοση',
  device_config_pulse_coef_not_changed_message:
    'Προειδοποίηση: Το προσαρμοσμένο "Συντελεστής παλμών" παραμένει αμετάβλητο από τις αλλαγές στην "Αρχική Μέτρηση"',
  device_config_does_not_support_this_model:
    'Αυτό το μοντέλο συσκευής δεν υποστηρίζεται σε αυτή τη σελίδα.',

  device_digits_fraction: 'Δεκαδικό',
  device_digits_digits: 'Ψηφία',
  device_digits_initial_reading: 'Αρχική Μέτρηση',
  device_digits_alert_too_many_total_digits: 'Ο συνολικός αριθμός των ψηφίων πρέπει να είναι <= 9',
  device_digits_alert_too_small_total_digits: 'Ο συνολικός αριθμός των ψηφίων πρέπει να είναι >= 4',
  device_digits_alert_too_many_total_fraction:
    'Ο συνολικός αριθμός ψηφίων μετά το δεκαδικό σημείο πρέπει να ειναι <= 3 και ο συνολικός αριθμός των ψηφίων πρέπει να είναι <= 9',
  device_digits_alert_too_small_total_fraction:
    'Ο αριθμός των ψηφίων μετά το δεκαδικό σημείο πρέπει να είναι >=0 και ο συνολικός αριθμός ψηφίων πρέπει να είναι >= 4',

  device_transmissions_at: 'Μεταδόσεις συσκευών στο {{query_date}}',
  device_transmissions_last_transmission_short: 'Τελευταία μετάδοση',
  device_transmissions_next_transmissions_short: 'Επόμενη μετάδοση',
  device_transmissions_days: 'Ημέρες',
  device_transmissions_transmissions_short: 'Μετάδοση',
  device_transmissions_count: 'Μετρώ',
  device_transmissions_fail: 'Αποτυγχάνω',
  device_transmissions_customer: 'Πελάτης',
  device_transmissions_address: 'Διεύθυνση',
  device_transmissions_ok: 'Ok',

  link_device_link_device_to_my_account: 'Σύνδεση συσκευής με τον λογαριασμό μου',
  link_device_device_number: 'Αριθμός Συσκευής',
  link_device_unlink_device: 'Αποσύνδεση Συσκευής',
  link_device_with_device_number: `Σύνδεση συσκευής: {{device_number}}`,
  unlink_device_with_device_number: `Αποσύνδεση συσκευής: {{device_number}}`,
  link_device_devices_counts:
    'Συνδεδεμένες συσκευές: {{linked_devices_count}} / {{allowed_devices_count}}',
  link_device_success_message: 'Η συσκευή συσχετίστηκε με επιτυχία',
  unlink_device_success_message: 'Η συσκευή αποσυνδέθηκε επιτυχώς από: ',
  link_device_enter_device_number_error: 'Εισαγάγετε έναν αριθμό συσκευής',
  link_device_select_company_error: 'Επιλέξτε μια εταιρεία',
  link_device_device_not_found_error: 'Η συσκευή {{device_number}} δεν βρέθηκε',
  link_device_device_not_linked_error: 'Η συσκευή {{device_number}} δεν είναι συνδεδεμένη',
  link_device_device_already_linked_error: 'Η συσκευή {{device_number}} είναι ήδη συνδεδεμένη',
  link_device_device_limit_reached_error: 'Έχει επιτευχθεί το όριο των συσκευών',
  link_device_operation_not_allowed_error: 'Η λειτουργία δεν επιτρέπεται',
  link_device_unlink_devices_for_sub_accounts: 'Αποσύνδεση συσκευής για όλους τους υπολογαριασμούς',
  link_device_unlink_devices_for_sub_accounts_tooltip:
    'Αν είναι επιλεγμένο, η συσκευή θα αποσυνδεθεί από τον επιλεγμένο και όλους τους υπολογαριασμούς. Αν δεν είναι επιλεγμένο, η συσκευή θα αποσυνδεθεί μόνο από τον επιλεγμένο λογαριασμό.',
  link_device_lookup_title: 'Αναζήτηση συσκευής',
  link_device_lookup_subheader:
    'Κάντε κλικ σε μια γραμμή αυτού του πίνακα για να συμπληρωθεί αυτόματα ο αριθμός συσκευής στη φόρμα σύνδεσης.',
  link_device_lookup_filter_number: 'Αριθμός',
  link_device_lookup_filter_name: 'Όνομα',
  link_device_lookup_device_name: 'Όνομα συσκευής',
  link_device_lookup_device_number: 'Αριθμός συσκευής',
  link_device_lookup_no_devices_found: 'Δεν βρέθηκαν συσκευές',

  device_search_device_number: 'Αριθμός Συσκευής',
  device_search_kicker: 'Πλαίσιο εταιρείας',
  device_search_title: 'Αναζήτηση εταιρείας ανά συσκευή',
  device_search_subtitle:
    'Αναζητήστε με αριθμό συσκευής και επιλέξτε την εταιρεία που πρέπει να παραμείνει ενεργή στο management.',
  device_search_device_number_placeholder: 'Εισάγετε αριθμό συσκευής',
  device_search_length_hint: 'Η αναζήτηση ξεκινά αυτόματα όταν σταματήσετε να πληκτρολογείτε.',
  device_search_clear: 'Καθαρισμός',
  device_search_selected_company: 'Επιλεγμένη εταιρεία',
  device_search_selected_company_hint:
    'Πατήστε ξανά την ίδια γραμμή για να καθαρίσετε την τρέχουσα επιλογή εταιρείας.',
  device_search_error: 'Αποτυχία φόρτωσης εταιρειών για αυτόν τον αριθμό συσκευής.',
  device_search_no_matches: 'Δεν βρέθηκαν εταιρείες για αυτόν τον αριθμό συσκευής.',
  device_search_results_title: 'Αντιστοιχισμένες εταιρείες',
  device_search_results_ready:
    'Επιλέξτε μια γραμμή για να ενημερώσετε το ενεργό πλαίσιο εταιρείας.',
  device_search_results_waiting: 'Εισάγετε αριθμό συσκευής για να ξεκινήσει η αναζήτηση.',
  device_search_empty_prompt: 'Εισάγετε αριθμό συσκευής για να αναζητήσετε εταιρείες.',
  device_search_empty_prompt_subtitle:
    'Τα αποτελέσματα θα εμφανιστούν εδώ όταν σταματήσετε να πληκτρολογείτε.',
  device_search_domain: 'Τομέας',

  device_manager_create_or_delete_device: 'Δημιουργία ή διαγραφή συσκευής: {{device_number}}',
  device_manager_device_number: 'Αριθμός Συσκευής',
  device_manager_device_model: 'Μοντέλο Συσκευής',
  device_manager_sw_version_validation:
    'Η απαιτούμενη μορφή είναι X.X.X ή X.X.X- και X.X.X_ ακολουθούμενη από χαρακτήρες, όπου X είναι ένας αριθμός.',
  device_manager_hw_version_validation: 'Η απαιτούμενη μορφή είναι X.X.X όπου X είναι ένας αριθμός',
  device_manager_software_version: 'Εκδοση λογισμικου',
  device_manager_hardware_version: 'Έκδοση Υλικού',

  dashboard_alarms: 'Συναγερμός',
  dashboard_batteries: 'Μπαταρίες',
  dashboard_signal: 'Σήμα',
  dashboard_transmission: '{{alarm_type}} ({{alarm_count}})',
  dashboard_chart_battery_level: 'Επίπεδο μπαταρίας',
  dashboard_chart_signal_level: 'Επίπεδο σήματος',
  dashboard_chart_number_of_devices: 'Αριθμός συσκευών',
  dashboard_select_company_header: 'Επιλέξτε έναν λογαριασμό για να δείτε τον πίνακα ελέγχου',
  dashboard_select_company_from: 'Από εδώ: ',
  dashboard_select_company_accounts_page_link: 'Λογαριασμοί',

  alarm_type_no_zero_consumption: 'Μη Μηδενική Κατανάλωση',
  alarm_type_high_consumption: 'Υψηλη Καταναλωση',
  alarm_type_high_flow: 'Υψηλη Ροη',
  alarm_type_missed_transmission: 'Αποτηχυμενη Μεταδοση',
  alarm_type_low_flow: 'Χαμηλη Ροη',
  alarm_type_all_zero_consumption: 'Μηδενικη Καταναλωση',
  alarm_type_device_removed: 'Η Συσκευη Αφαιρεθηκε',
  alarm_type_on_off_alarm: 'Συναγερμός ενεργοποίηση/απενεργοποίηση',
  alarm_type_low_level: 'Χαμηλό Επίπεδο',
  alarm_type_high_level: 'Υψηλό Επίπεδο',
  alarm_type_tamper: 'Παραβίαση',
  alarm_type_oversized: 'Υπερμεγέθη',
  alarm_type_undersized: 'Κάτω του κανονικού μέγεθους',
  alarm_type_low_battery: 'Χαμηλή μπαταρία',
  alarm_type_blockage: 'Εμφραξη',
  alarm_type_burst: 'Εκρηξη',
  alarm_type_reverse_flow: 'Αντίστροφη ροή',
  alarm_type_range_event: 'Συμβάν εύρους',
  alarm_type_very_low_level: 'Πολύ χαμηλή στάθμη',
  alarm_type_very_high_level: 'Πολύ υψηλή στάθμη',
  alarm_type_leakage: 'Διαρροή',
  alarm_type_low_temperature: 'Χαμηλή θερμοκρασία',
  alarm_type_no_consumption: 'Καμία κατανάλωση',
  alarm_type_negative_flow: 'Αρνητική ροή',
  alarm_type_empty_spool: 'Άδειος σωλήνας',
  alarm_type_combination_of_alarms: 'Συνδυασμός συναγερμών',
  alarm_type_standstill: 'Ακινησία',
  alarm_type_reset_error: 'Σφάλμα επανεκκίνησης',
  alarm_type_rf_error: 'Σφάλμα RF',
  alarm_type_cs_error: 'Σφάλμα CS',
  alarm_type_measuring_error: 'Σφάλμα μέτρησης',
  alarm_type_reset_event: 'Επανεκκίνηση',
  alarm_type_magnetic_field: 'Μαγνητικό πεδίο',
  alarm_type_sensor_fraud: 'Παραποίηση αισθητήρα',

  device_counter_graph_min: 'Ελάχιστη: {{min}}',
  device_counter_graph_max: 'Μέγιστη: {{max}}',
  device_counter_graph_avg: 'Μέσος όρος: {{avrg}}',
  device_counter_graph_total: 'Σύνολο: {{total}}',
  device_counter_graph_average: 'Μέση τιμή:',
  device_counter_graph_no_data: 'Χωρίς δεδομένα',
  device_counter_graph_cant_calculate_flow_analog:
    'Δεν είναι δυνατός ο υπολογισμός ροής για αναλογικό αισθητήρα!',
  device_counter_graph_must_have_digital_sensor:
    'Πρέπει να έχετε έναν ενεργοποιημένο ψηφιακό αισθητήρα.',

  customer_info_header: 'Πληροφορίες πελάτη',
  customer_info_business_partner_number: 'Αριθμός συνεργάτη',
  customer_info_contact_data: 'στοιχεία επικοινωνίας',
  customer_info_contract_number: 'Αριθμός Συμβολαίου',
  customer_info_name: 'Ονομα',
  customer_info_description: 'Περιγραφή',
  customer_info_billing_group: 'Ομάδα χρέωσης',
  customer_info_municipality: 'Δήμος',
  customer_info_quarter: 'Τέταρτο',
  customer_info_street: 'Δρόμος',
  customer_info_block: 'Γειτονιά',
  customer_info_entr: 'Είσοδος',
  customer_info_customer_type: 'Τύπος πελάτη',
  customer_info_customer_type_commercial: 'Εμπορικός',
  customer_info_customer_type_domestic: 'Οικιακός',
  customer_info_customer_type_block_of_flats: 'Πολυκατοικία',
  customer_info_customer_type_budget: 'Προϋπολογισμός',

  meter_info_meter_info: 'Πληροφορίες Μετρητή: {{device_number}}',
  meter_info_factory_number: 'Αριθμός Εργοστασίου',
  meter_info_brand: 'Μάρκα',
  meter_info_enter_diameter: 'Εισαγάγετε Τη Διάμετρο',
  meter_info_mount_date: 'Ημερομηνία Προσάρτησης',
  meter_info_meter_info_saved: 'Οι Πληροφορίες Του Μετρητή Αποθηκεύτηκαν.',

  device_initial_config_header: 'Αρχική διαμόρφωση συσκευής',
  device_initial_device_model: 'Μοντέλο συσκευής',
  device_initial_config_address: 'Διεύθυνση',
  device_initial_config_port: 'Λιμάνι',
  device_initial_config_resolve_address: 'Επίλυση διεύθυνσης (χρήση DNS)',
  device_initial_config_simcard_provider: 'Πάροχος κάρτας Sim',
  device_initial_config_simcard_number: 'Αριθμός κάρτας Sim',
  device_initial_config_bands: 'bands',
  device_initial_config_OTAA_appkey: 'OTAA - appkey',
  device_initial_config_OTAA_deveui: 'OTAA - deveui',
  device_initial_config_OTAA_appeui: 'OTAA - appeui',
  device_initial_config_ABP_appskey: 'ABP - appskey',
  device_initial_config_ABP_nwkskey: 'ABP - nwkskey',
  device_initial_config_ABP_devaddr: 'ABP - devaddr',
  device_initial_config_ABP_deveui: 'ABP - deveui',
  device_initial_config_lora_app_mode: 'Λειτουργία εφαρμογής',
  device_initial_config_app_id: 'ID εφαρμογής',
  device_initial_config_profile_id: 'ID προφίλ',
  device_initial_config_platform_name: 'Όνομα πλατφόρμας',
  device_initial_config_thingslog_lora_platform: 'ThingsLog πλατφόρμα LoRa',
  device_receive_data_binary: 'Λήψη δυαδικών δεδομένων',
  device_send_data_binary: 'Δυαδική αποστολή δεδομένων',
  device_mqtt_config: 'MQTT διαμόρφωση',
  device_mqtt_config_qos: 'Ποιότητα εξυπηρέτησης',
  device_mqtt_config_username: 'Όνομα χρήστη',
  device_mqtt_config_password: 'Κωδικός πρόσβασης',
  device_mqtt_config_certificate: 'Πιστοποιητικό',
  device_initial_config_apn_username: 'Όνομα Χρήστη APN',
  device_initial_config_apn_password: 'Κωδικός APN',
  device_initial_config_gprs_radio_mode: 'Λειτουργία ραδιοφώνου GPRS',
  device_initial_config_grps_radio_mode_auto_option: 'Αυτόματο',
  device_initial_config_net_attached_delay: 'Καθυστέρηση μετάδοσης',
  device_initial_config_preferred_network_type: 'Προτιμώμενος Τύπος Δικτύου',
  device_initial_config_preferred_network_default_option: 'Προεπιλογή',
  device_initial_config_mcc_mnc: 'MCC-MNC',
  device_initial_config_slave_devices: 'Συσκευές Slave',
  device_initial_config_modbus_address: 'Διεύθυνση Modbus',
  device_initial_config_modbus_master_device: 'Αριθμός κύριου συσκευής',
  device_initial_config_trashcan_brand: 'Μάρκα',
  device_initial_config_trashcan_model: 'Μοντέλο',
  device_initial_config_trashcan_volume: 'Όγκος',
  device_initial_config_trashcan_max_weight: 'Μέγιστο βάρος',
  device_initial_config_trashcan_material: 'Υλικό',
  device_initial_config_trashcan_color: 'Χρώμα',
  device_initial_config_trashcan_waste_type: 'Τύπος απορριμμάτων',
  device_initial_config_trashcan_waste_type_plastic: 'Πλαστικό',
  device_initial_config_trashcan_waste_type_bio: 'Βιο',
  device_initial_config_trashcan_waste_type_paper: 'Χαρτί',
  device_initial_config_trashcan_waste_type_glass: 'Γυαλί',
  device_initial_config_trashcan_waste_type_metal: 'Μέταλλο',
  device_initial_config_trashcan_waste_type_mixed: 'Μικτό',
  device_initial_config_trashcan_waste_type_other: 'Άλλο',
  device_initial_config_trashcan_pricing: 'Τιμολόγηση',
  device_initial_config_trashcan_pricing_free: 'Δωρεάν',
  device_initial_config_trashcan_pricing_per_lift: 'Ανά συλλογή',
  device_initial_config_trashcan_pricing_per_kg: 'Ανά κιλό',
  device_initial_config_trashcan_pricing_per_subscription: 'Ανά συνδρομή',
  device_initial_config_trashcan_placement: 'Τοποθέτηση',
  device_initial_config_trashcan_placement_on_the_street: 'Στο δρόμο',
  device_initial_config_trashcan_placement_inside: 'Μέσα',
  device_initial_config_trashcan_placement_backyard: 'Αυλή',
  device_initial_config_trashcan_customer_community_id: 'Ταυτότητα κοινότητας πελατών',
  device_initial_config_trash_truck_brand: 'Μάρκα',
  device_initial_config_trash_truck_plate_number: 'Αριθμός πινακίδας',
  device_initial_config_trash_truck_model: 'Μοντέλο',
  device_initial_config_find_encryption_key_by_device_number:
    'Βρείτε το κλειδί κρυπτογράφησης με αριθμό συσκευής',

  sensor_config_header: 'Διαμόρφωση Αισθητήρα',
  sensor_config_name: 'Ονομα',
  sensor_config_sensor_name: 'Όνομα Αισθητήρα',
  sensor_config_sensor_icon: 'Όνομα εικονιδίου',
  sensor_config_description: 'Περιγραφή',
  sensor_config_model: 'Μοντέλο',
  sensor_config_serial_number: 'Σειριακός Αριθμός',
  sensor_config_manufacturer: 'Κατασκευαστής',
  sensor_config_diameter: 'Διάμετρος',
  sensor_config_price: 'Τιμή',
  sensor_config_currency: 'Νόμισμα',
  sensor_config_supported_visualization_types: 'Υποστηριζόμενοι τύποι οπτικοποίησης',
  sensor_config_port_type: 'Τύπος θύρας',
  sensor_config_port_type_digital_input_port: 'Ψηφιακή Θύρα Εισόδου',
  sensor_config_port_type_analog_input_port: 'Θύρα Αναλογικής Εισόδου',
  sensor_config_port_type_pulse_s0_input_port: 'Θύρα Εισόδου Παλμού S0',
  sensor_config_port_type_pulse_input_port: 'Θύρα Εισόδου Παλμού',
  sensor_config_port_type_on_off_input_port: 'Απενεργοποιημένη Θύρα Εισόδου',
  sensor_config_port_type_on_off_output_port: 'Θύρα Εξόδου Εκτός Λειτουργίας',
  sensor_config_port_conversion_formula: 'Τύπος Μετατροπής Λιμένων',
  sensor_config_formula: 'Τύπος',
  sensor_config_offset: 'Αντισταθμίζεται',
  sensor_config_sensor_index_tooltip: 'δείκτης αισθητήρα: {{sensor_index}}',
  sensor_config_visible: 'Ορατότητα',
  sensor_config_order_number: 'Αριθμός παραγγελίας',
  sensor_config_visible_true: 'Ορατό',
  sensor_config_visible_false: 'Αόρατος',
  sensor_config_use_in_sensor_aggregation: 'Χρήση στη συγκέντρωση αισθητήρων',
  sensor_config_use_in_sensor_aggregation_true: 'Χρήση',
  sensor_config_use_in_sensor_aggregation_false: 'Μη χρήση',
  sensor_config_value_labels: 'Ετικέτες Τιμών',
  sensor_config_label_for_value_zero: 'Ετικέτα για την τιμή "0"',
  sensor_config_label_for_value_one: 'Ετικέτα για την τιμή "1"',
  sensor_config_inverted_read_state_value: 'Αντεστραμμένη κατάσταση ανάγνωσης',
  sensor_config_inverted_read_state_value_true: 'Αντιστραμμένο',
  sensor_config_inverted_read_state_value_false: 'Μη αντιστραμμένο',
  sensor_config_register_address: 'Διεύθυνση μητρώου',
  sensor_config_data_type: 'Τύπος δεδομένων',
  sensor_config_count: 'Πλήθος',
  sensor_config_number_registers: 'Αριθμός καταχωρητών',
  sensor_config_particle_size: 'Μέγεθος σωματιδίων',
  sensor_config_power: 'Ισχύς',
  sensor_config_measurement_type: 'Τύπος μέτρησης',
  sensor_config_measurement_group: 'Ομάδα μέτρησης',
  tasmota_generic_digital_sensor: 'Γενικός ψηφιακός αισθητήρας Tasmota',
  tasmota_alarm_input_sensor: 'Αισθητήρας εισόδου συναγερμού Tasmota',
  tasmota_generic_analog_sensor: 'Γενικός αναλογικός αισθητήρας Tasmota',

  device_counter_statistics_statistics_id: 'Στατιστική, id: {{device_number}}, {{description}}',
  device_counter_statistics_quarter: 'Τέταρτο',
  device_counter_statistics_flow: 'Ροή',
  device_counter_statistics_hour: 'Ωρα',
  device_counter_statistics_quantity: 'Ποσότητα',
  device_counter_statistics_value: 'Αξία',
  device_counter_statistics_digital_ports_must_be_present:
    'Για να δείτε αυτόν τον πίνακα, πρέπει να συνδέσετε μια είσοδο παλμού σε έναν αισθητήρα μετρητή νερού.',
  device_counter_statistics_name_must_have_initialized_value:
    'Οι παράμετροι Q3, R και Διάμετρος απαιτούνται στην είσοδο παλμού συνδεδεμένη με έναν αισθητήρα μετρητή νερού.',

  company_manager_title: 'Δημιουργία ή διαγραφή λογαριασμού: {{company_name}}',
  company_manager_account_name: 'Όνομα λογαριασμού',
  company_manager_solution: 'Είδος έργου',
  company_manager_solution_option_none: 'Незададен',
  company_manager_solution_option_agri: 'Χωρίς ανάθεση',
  company_manager_solution_option_air_quality: 'Καθαρος ΑΕΡΑΣ',
  company_manager_solution_option_street_lights: 'Φωτισμός δρόμου',
  company_manager_solution_option_pump_station: 'Αντλιοστάσιο',
  company_manager_solution_option_smart_waste: 'Έξυπνα Απορρίμματα',
  company_manager_solution_option_level: 'Παρακολούθηση επιπέδου',
  company_manager_solution_option_gas: 'Παρακολούθηση αερίου',
  company_manager_solution_option_pressure: 'Παρακολούθηση πίεσης',
  company_manager_solution_option_smart_water: 'Έξυπνο Νερό',
  company_manager_solution_option_environment_monitoring: 'Παρακολούθηση περιβάλλοντος',
  company_manager_solution_option_energy: 'Παρακολούθηση ενέργειας',
  company_manager_license: 'Άδεια',
  company_manager_account: 'Λογαριασμός',
  company_manager_create_company: 'Δημιουργία Εταιρείας',
  company_manager_create_company_error: 'Υπήρξε πρόβλημα κατά τη δημιουργία της εταιρείας σας',
  company_manager_license_info_box:
    'Η προσάρτηση της άδειας απαιτεί έγκυρο ID λογαριασμού. Ελέγξτε δύο φορές την τιμή του ID λογαριασμού σας, αν θέλετε να το συμπεριλάβετε στη διαδικασία δημιουργίας.',
  company_manager_valid_from: 'Έγκυρο από',
  company_manager_valid_to: 'Έγκυρο έως',
  company_manager_solution_type: 'Τύπος Λύσης',
  company_manager_contact_id: 'Ταυτότητα Επαφής',
  company_manager_account_id: 'Ταυτότητα Λογαριασμού',
  company_manager_license_type: 'Τύπος Άδειας',
  company_manager_timezone: 'Ζώνη ώρας',
  company_manager_country: 'Χώρα',
  company_manager_countries_error: 'Δεν ήταν δυνατή η φόρτωση των χωρών',
  company_manager_timezones_error: 'Δεν ήταν δυνατή η φόρτωση των ζωνών ώρας',
  company_manager_account_info: 'Πληροφορίες λογαριασμού',
  company_manager_address: 'Διεύθυνση',
  company_manager_city: 'Πόλη',
  company_manager_municipality: 'Δήμος',
  company_manager_area: 'Περιοχή',
  company_manager_zip_code: 'Ταχυδρομικός κώδικας',
  company_manager_vat_number: 'Αριθμός ΦΠΑ',
  company_manager_account_ext_number: 'Εξωτερικός αριθμός λογαριασμού',
  company_manager_account_ext_type: 'Εξωτερικός τύπος λογαριασμού',
  company_manager_account_ext_type_none: 'Κανένα',
  company_manager_account_ext_type_household: 'Νοικοκυριό',
  company_manager_account_ext_type_business: 'Επιχείρηση',

  company_manager_license_per_device: 'Ανά συσκευή',
  company_manager_license_per_reading: 'Ανά αναφορά',
  company_manager_license_per_sensor: 'Ανά αισθητήρα',
  company_manager_license_per_poc: 'Ανά Απόδειξη της Έννοιας (POC)',
  company_manager_license_per_remote_node: 'Ανά Απομακρυσμένος Κόμβος',

  company_manager_creating_account: 'Δημιουργία λογαριασμού: {{company_name}}',
  company_manager_deleting_account: 'Διαγραφή λογαριασμού: {{company_name}}',
  company_manager_account_created: 'Επιτυχής δημιουργία λογαριασμού',
  company_manager_account_deleted: 'Επιτυχής διαγραφή λογαριασμού',

  company_manager_update_company: 'Ενημέρωση λογαριασμού',
  company_manager_delete_company: 'Διαγραφή λογαριασμού',
  company_manager_actions: 'Ενέργειες',
  company_manager_delete_modal_description:
    'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον λογαριασμό; Η ενέργεια είναι μη αναστρέψιμη.',
  company_manager_confirm_button: 'Επιβεβαίωση',
  company_manager_cancel_button: 'Ακύρωση',
  company_manager_delete_company_error_message:
    'Παρουσιάστηκε σφάλμα κατά τη διαγραφή του λογαριασμού',
  company_manager_update_btn: 'Ενημέρωση',
  company_manager_child_company_warning_message: 'Δημιουργία υπολογαριασμού της',
  company_manager_current_logged_in_company: 'λογαριασμού στον οποίο είστε συνδεδεμένοι',
  company_manager_current_selected_company: 'λογαριασμού που έχετε επιλέξει αυτήν τη στιγμή',
  accounts_child_companies: 'Υπολογαριασμοί',
  accounts_contactRef: 'Ταυτότητα Επαφής',
  accounts_externalNumber: 'Εξωτερικός αριθμός',
  accounts_accountRef: 'Ταυτότητα Λογαριασμού',
  accounts_logo: 'Λογότυπο',
  accounts_info_unavailable: 'Δεν υπάρχουν πληροφορίες εταιρείας για αυτόν τον λογαριασμό.',
  company_manager_accountRef_is_disabled_because_of_license_type:
    'Η ταυτότητα λογαριασμού απενεργοποιείται λόγω άδειας ανά POC',
  accounts_none: 'Κανένα',
  company_manager_update_company_success: 'Ο λογαριασμός ενημερώθηκε με επιτυχία',
  company_manager_update_company_error: 'Παρουσιάστηκε σφάλμα κατά την ενημέρωση του λογαριασμού',
  company_manager_account_name_exists: 'Υπάρχει ήδη λογαριασμός με αυτό το όνομα.',

  license_manager_title: 'Ανανέωση άδειας: {{company_name}}',
  license_manager_license: 'Άδεια',
  license_manager_license_updated: 'Η άδεια ανανεώθηκε',

  companies_title: 'Αριθμός λογαριασμών: {{company_number}}',
  companies_table_name: 'Ονομα',
  companies_number_of_accounts: 'Αριθμός λογαριασμών:',
  companies_search: 'Αναζήτηση',

  users_title: 'Χρήστες',
  units_type: 'Τύπος μονάδων',

  reports_export_format_type: 'Μορφή',

  pump_auto_every: 'Auto every {{secs}} secs',
  pump_svg_last_updated: 'Last updated: {{timestamp}}',
  pump_svg_power_supply: 'Power Supply',
  pump_svg_water_level_controller: 'Water Level Controller',
  pump_svg_pump: 'Pump',
  pump_svg_level_sensor: 'Level Sensor',
  pump_svg_pump_on_sensor: 'Pump-on Sensor',
  pump_svg_pump_off_sensor: 'Pump-off Sensor',
  pump_svg_dry_run_sensor: 'Dry Run Sensor',

  device_groups_error_please_select_company: 'Επιλέξτε μια εταιρεία.',

  device_groups_btn_add: 'Προσθήκη',
  device_groups_btn_edit: 'Επεξεργασία',
  device_groups_btn_delete: 'Διαγράφω',
  device_groups_btn_cancel: 'Ακυρώνω',
  device_groups_tooltip_edit: 'Επεξεργασία',
  device_groups_tooltip_delete: 'Διαγράφω',
  device_groups_color_picker_label: 'Χρώμα ομάδας συσκευών',

  device_groups_name: 'Ονομα',
  device_groups_devices: 'Συσκευές',
  device_groups_view_devices: 'Προβολή {{count}} συσκευών',
  device_groups_group_name: 'Ονομα ομάδας',
  device_groups_parent_device_group: 'Ομάδα συσκευών γονέων',
  device_groups_auto_device_group_type_label: 'Αυτόματη ομάδα συσκευών',
  device_groups_auto_device_group_type_none: 'Χωρίς αυτόματη ομάδα',
  device_groups_auto_device_group_type_all_devices: 'Όλες οι συσκευές',
  device_groups_auto_device_group_type_all_water: 'Όλες οι συσκευές νερού',
  device_groups_auto_device_group_type_all_energy: 'Όλες οι συσκευές ενέργειας',
  device_groups_auto_device_group_type_all_pressure: 'Όλοι οι αισθητήρες πίεσης',
  device_groups_auto_device_group_type_all_barometric_pressure:
    'Όλοι οι αισθητήρες βαρομετρικής πίεσης',
  device_groups_auto_device_group_type_all_levels: 'Όλοι οι αισθητήρες στάθμης',
  device_groups_auto_device_group_type_all_soil_moisture: 'Όλοι οι αισθητήρες υγρασίας εδάφους',
  device_groups_auto_device_group_type_all_air_humidity: 'Όλοι οι αισθητήρες υγρασίας αέρα',
  device_groups_auto_device_group_type_all_temperatures: 'Όλοι οι αισθητήρες θερμοκρασίας',
  device_groups_auto_device_group_type_all_pm10: 'Όλοι οι αισθητήρες PM10',
  device_groups_auto_device_group_type_all_pm2_5: 'Όλοι οι αισθητήρες PM2.5',
  device_groups_auto_device_group_type_unknown: 'Άγνωστη αυτόματη ομάδα',
  device_groups_auto_device_group_alert_title: 'Η αυτόματη ομάδα συσκευών είναι ενεργή',
  device_groups_auto_device_group_alert_description: 'Αυτή η ομάδα έχει ρυθμιστεί ως {{type}}.',
  device_groups_auto_device_group_change: 'Αλλαγή',
  device_groups_auto_device_group_change_modal_title: 'Αλλαγή αυτόματης ομάδας συσκευών',
  device_groups_menuitem_none: 'Κανένας',
  device_groups_add_device_group: 'Προσθήκη ομάδας συσκευών',
  device_groups_edit_device_group: 'Επεξεργασία ομάδας συσκευών',
  device_groups_delete_device_group: 'Διαγραφή ομάδας συσκευών',

  device_grous_add_sensor_device: 'Προσθήκη αισθητήρα και συσκευής στην ομάδα',

  device_groups_table_sensor_group_name_header: 'Όνομα ομάδας αισθητήρων',
  device_groups_table_parent_group_name_header: 'Όνομα γονικής ομάδας',
  device_groups_table_device_count_header: 'Πλήθος συσκευών',

  device_groups_sensor_table_device_number_header: 'Αριθμός συσκευής',
  device_groups_sensor_table_sensor_name_header: 'Όνομα αισθητήρα',
  device_groups_sensor_table_sensor_index_header: 'Δείκτης αισθητήρων',
  device_groups_sensor_table_select_message: 'Επιλογή ομάδας αισθητήρων',

  device_groups_sensors_add_modal_device_placeholder: 'Αριθμός συσκευής',
  device_groups_sensors_add_modal_sensor_placeholder: 'Αισθητήραςr',
  device_groups_sensors_add_modal_device_group_name_required: 'Απαιτείται όνομα ομάδας συσκευών',

  device_groups_sensors_delete_description:
    'Η διαγραφή αυτής της ρύθμισης παραμέτρων θα την καταργήσει οριστικά από το διακομιστή.',
  device_groups_device_group_delete_description:
    'Η διαγραφή της ομάδας συσκευών θα την καταργήσει οριστικά από το διακομιστή.',

  device_groups_select_company_header: 'Επιλέξτε μια εταιρεία για να προχωρήσετε',
  device_groups_select_company_from: 'Από εδώ: ',
  device_groups_select_company_accounts_page_link: 'Σελίδα Λογαριασμών',

  device_groups_create_device_group_error:
    'Προέκυψε πρόβλημα κατά τη δημιουργία μιας νέας ομάδας συσκευών',
  device_groups_update_device_group_error:
    'Προέκυψε πρόβλημα κατά την ενημέρωση της ομάδας συσκευών',
  device_groups_delete_device_group_error: 'Προέκυψε πρόβλημα κατά τη διαγραφή της ομάδας συσκευών',
  device_groups_add_device_sensor_device_group_error:
    'Προέκυψε πρόβλημα κατά την προσθήκη του αισθητήρα',
  device_groups_remove_device_sensor_device_group_error:
    'Προέκυψε πρόβλημα κατά την αφαίρεση του αισθητήρα',

  /*
   * |==============|
   * | Users Config |
   * |==============|
   */

  //Page
  users_header: 'Χρήστες',
  users_table_username: 'Όνομα χρήστη',
  users_table_first_name: 'Ονομα',
  users_table_last_name: 'Επίθετο',
  users_table_company_name: 'λογαριασμός',
  users_table_email: 'ηλεκτρονικού ταχυδρομείου',

  //Filters
  users_filter_username: 'Φιλτράρισμα ονόματος χρήστη',
  users_filter_first_name: 'Όνομα φίλτρου',
  users_filter_last_name: 'Φιλτράρισμα επωνύμου',
  users_filter_email: 'Φιλτράρισμα email',
  users_filter_company_name: 'Φιλτράρισμα λογαριασμού',
  users_reset_filter_icon: 'Επαναφορά φίλτρων',
  users_table_is_contact_person: 'Πρόσωπο επικοινωνίας',

  //Modals
  users_add_modal_header: 'Πρόσθεσε χρήστη',
  users_update_modal_header: 'Ενημέρωση χρήστη',
  user_remove_modal_icon: 'Διαγραφή χρήστη',
  users_remove_modal_header: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε χρήστη {{username}}',
  users_remove_modal_body:
    'Κάνοντας κλικ στην επιλογή Κατάργηση θα διαγράψετε οριστικά τον επιλεγμένο χρήστη από το διακομιστή.',
  users_is_dashboard_enabled: 'Ταμπλό Ενεργοποιημένο',
  users_is_contact_person: 'Πρόσωπο Επικοινωνίας',

  //Errors
  users_password_match: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
  users_email_blank: 'Το email δεν μπορεί να είναι κενό',
  users_load_error: 'Δεν ήταν δυνατή η φόρτωση των χρηστών',
  users_update_error: 'Δεν ήταν δυνατή η ενημέρωση του χρήστη',
  users_delete_error: 'Δεν ήταν δυνατή η διαγραφή του χρήστη',
  users_create_error: 'Δεν ήταν δυνατή η δημιουργία του χρήστη',

  // Success
  users_update_success: 'Ο χρήστης ενημερώθηκε επιτυχώς',
  users_delete_success: 'Ο χρήστης διαγράφηκε επιτυχώς',
  users_create_success: 'Ο χρήστης δημιουργήθηκε επιτυχώς',
  /*
   * |=====================|
   * | Value Ranges Config |
   * |=====================|
   */

  // Buttons & tooltips
  value_ranges_btn_add: 'Προσθήκη',
  value_ranges_btn_defaults: 'Προεπιλογές',
  value_ranges_line_color: 'Χρώμα γραμμής',
  value_ranges_node_color: 'Χρώμα κόμβου',
  value_ranges_foreground_color: 'Χρώμα προσκηνίου',
  value_ranges_background_color: 'Χρώμα του φόντου',
  value_ranges_loading: 'Φόρτωση...',
  value_ranges_nothing_to_show: 'Δεν υπάρχει τίποτα για να δείξει',

  //Page
  value_ranges_header: 'Συμβάντα εύρους τιμών',
  value_ranges_trigger: 'έναυσμα α',
  value_ranges_notifications: 'ειδοποιήσεις',
  value_ranges_before: 'Πριν',
  value_ranges_after: 'Μετά',
  value_ranges_disabled: 'απενεργοποιημένο',
  value_ranges_date_range: 'Εύρος ημερομηνιών',
  value_ranges_daily_time_slot: 'Ημερήσια χρονική ζώνη',
  value_ranges_timezone: 'Ζώνη ώρας',

  //Modals
  value_ranges_add_event: 'Προσθήκη συμβάντος',
  value_ranges_edit_event: 'Επεξεργασία συμβάντος',
  value_ranges_add_default_events: 'Προσθήκη προεπιλεγμένων συμβάντων',
  value_ranges_remove_modal_header: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το εύρος τιμών',
  value_ranges_remove_modal_body:
    'Κάνοντας κλικ στην αφαίρεση θα διαγραφεί οριστικά το επιλεγμένο εύρος τιμών',

  //Form
  value_range_form_name: 'Όνομα συμβάντος',
  value_range_form_function: 'Λειτουργία',
  value_range_form_sensor: 'Αισθητήρας',
  value_range_form_description: 'Περιγραφή',
  value_range_form_min: 'Min',
  value_range_form_max: 'Max',
  value_range_form_severity: 'Σοβαρότητα',
  value_range_form_start_day: 'Ημέρα έναρξης',
  value_range_form_start_month: 'Μήνας έναρξης',
  value_range_form_start_time: 'Ωρα έναρξης',
  value_range_form_end_day: 'Ημέρα τέλους',
  value_range_form_end_month: 'Τελικός Μήνας',
  value_range_form_end_time: 'Τέλος χρόνου',
  value_range_form_enable_events: 'Ενεργοποίηση συμβάντων;',
  value_range_form_select_color: 'Επιλεγμένο χρώμα',
  value_range_form_notification_email: 'ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ',
  value_range_form_notification_push_notification: 'Ειδοποίηση τηλεφώνου',
  value_range_form_notification_sms: 'γραπτό μήνυμα',
  value_range_form_notification_push: 'ειδοποιήσεις push',
  value_range_form_notification_call: 'Κλήση',
  value_range_form_line_custom_color: 'Προσαρμοσμένο χρώμα γραμμής',
  value_range_form_marker_custom_color: 'Χρώμα προσαρμοσμένου δείκτη',
  value_range_form_no_notifications: 'Δεν υπάρχουν ειδοποιήσεις',

  //Errors
  value_range_tooltip_severity:
    'Οι σοβαρότητες που είναι μεγαλύτερες από 7 θεωρούνται σοβαρές. Τα σοβαρά συμβάντα σημαίνονται με ένα θαυμαστικό.',
  value_range_error_add: 'Δεν ήταν δυνατή η προσθήκη συμβάντος',
  value_range_error_edit: 'Δεν ήταν δυνατή η επεξεργασία του συμβάντος',
  value_range_name_is_required: 'Το όνομα απαιτείται',
  value_range_name_already_exists:
    'Το όνομα συμβάντος υπάρχει ήδη για αυτήν τη συσκευή και τον αισθητήρα',
  value_range_name_incorect_time: 'Λανθασμένη μορφή ώρας',
  value_range_min_greater_than_max: 'Το ελάχιστο δεν μπορεί να είναι μεγαλύτερο από το μέγ',
  value_range_min_equal_to_max: 'Το ελάχιστο δεν μπορεί να είναι ίσο με το μέγιστο',
  value_range_min_max_is_required: 'Απαιτείται ελάχιστο ή μέγιστο',
  value_range_error_occured: 'Παρουσιάστηκε σφάλμα',
  value_range_start_incorrect_time:
    'Η ώρα έναρξης έχει λανθασμένη μορφή. Θα πρέπει να είναι HH:mm. Σωστό: 01:00. Λάθος: 1:00.',
  value_range_end_incorrect_time:
    'Η ώρα λήξης έχει λανθασμένη μορφή. Θα πρέπει να είναι HH:mm. Σωστό: 01:00. Λάθος: 1:00.',
  value_range_start_day_missing_start_month: 'Η ημέρα έναρξης πρέπει να έχει μήνα έναρξης',
  value_range_end_day_missing_end_month: 'Η ημέρα λήξης πρέπει να έχει μήνα λήξης',
  value_range_start_month_missing_start_day: 'Ο μήνας έναρξης πρέπει να έχει ημέρα έναρξης',
  value_range_end_month_missing_end_day: 'Ο τελικός μήνας θα πρέπει να έχει ημέρα λήξης',
  value_range_mixed_alphabets_error:
    'Εντοπίστηκε χρήση μεικτών αλφάβητων, χρησιμοποιήστε μόνο μία γλώσσα',

  /*
   * |==========|
   * | Commands |
   * |==========|
   */

  // Command State
  commands_command_state_pending: 'Σε εκκρεμότητα',
  commands_command_state_sent: 'Απεσταλμένο',
  commands_command_state_cancelled: 'Ακυρώθηκε',
  commands_command_state_status_ok: 'Εντάξει',
  commands_command_state_status_nok: 'Μη εντάξει',
  commands_command_state_unknown: 'Άγνωστο',
  commands_command_state_timeout: 'Ο χρόνος αναμονής έχει λήξει',

  // Command Type
  commands_command_type_relay_switch: 'Διακόπτης ρελέ',
  commands_command_type_single_relay_switch: 'Διακόπτης μονού ρελέ',
  commands_command_type_relay_switch_with_delay: 'Διακόπτης ρελέ με καθυστέρηση',
  commands_command_type_relay_statuses: 'Καταστάσεις ρελέ',
  commands_command_type_send_config_over_mqtt: 'Αποστολή ρυθμίσεων μέσω MQTT',
  commands_command_type_send_date_over_mqtt: 'Αποστολή ημερομηνίας μέσω MQTT',
  commands_command_type_modbus: 'Modbus',
  commands_command_type_tasmota_relay_switch: 'Εντολή ρελέ Tasmota',
  commands_command_type_reset: 'Επαναφορά',
  commands_command_type_scheduled_relay_command: 'Προγραμματισμένη εντολή ρελέ',
  commands_command_type_scheduled_relay_command_4: 'Προγραμματισμένες εντολές ρελέ (4)',

  // Errors
  commands_error_missing_device_number: 'Device Number missing or wrong.',

  // Buttons
  commands_btn_send_command: 'Send Command',
  commands_btn_refresh: 'Ενημερώνω',
  commands_btn_submit: 'Submit',

  // Tooltips
  commands_tooltip_edit: 'Edit',

  // Popups
  commands_send_command: 'Send Command',
  commands_edit_command: 'Edit Command',
  commands_command_type: 'Command Type',
  commands_parameters: 'Parameters',
  commands_parameter_name: 'Parameter Name',
  commands_parameter_value: 'Parameter Value',

  // Page
  commands_header: 'Commands',
  commands_type: 'Type',
  commands_status: 'Status',
  commands_relay_1_status: 'Relay 1 Status',
  commands_relay_2_status: 'Relay 2 Status',
  commands_created: 'Created',
  commands_sent: 'Sent',
  commands_executed: 'Executed',
  commands_relay_status: 'Κατάσταση ρελέ',
  commands_relay_index: 'Δείκτης ρελέ',

  commands_sensor_index: 'Δείκτης αισθητήρα',
  commands_slave_device_number: 'Αριθμός υποτελούς συσκευής',
  commands_hour: 'Ώρα',
  commands_minutes: 'Λεπτά',
  commands_auto_refresh: 'Αυτόματη ανανέωση',
  commands_no_commands: 'Δεν έχουν σταλεί ακόμη εντολές σε αυτή τη συσκευή.',
  commands_no_parameters: 'Αυτή η εντολή δεν δέχεται παραμέτρους.',
  commands_no_parameter_values: 'Δεν υπάρχουν διαθέσιμες τιμές για αυτή τη συσκευή.',
  commands_schedule_group: 'Πρόγραμμα {{index}}',
  commands_cancel_command: 'Ακύρωση εντολής',
  commands_cancel_command_confirm:
    'Αυτή η εντολή δεν έχει σταλεί ακόμη. Η ακύρωσή της εμποδίζει την παράδοσή της στη συσκευή.',
  commands_cancel_command_success: 'Η εντολή ακυρώθηκε',
  commands_send_command_success: 'Η εντολή στάλθηκε',
  commands_btn_close: 'Κλείσιμο',
  commands_btn_keep: 'Διατήρηση',
  commands_parameters_empty: 'Χωρίς παραμέτρους',
  commands_command_id: 'Αναγν.',
  commands_error_send_failed: 'Η εντολή δεν μπόρεσε να σταλεί.',
  commands_error_cancel_failed: 'Η εντολή δεν μπόρεσε να ακυρωθεί.',
  commands_error_parameters_failed: 'Οι παράμετροι αυτής της εντολής δεν μπόρεσαν να φορτωθούν.',
  commands_only_pending_can_be_cancelled: 'Μόνο οι εκκρεμείς εντολές μπορούν να ακυρωθούν.',
  commands_last_updated: 'Ενημερώθηκε στις {{time}}',
  commands_error_list_failed: 'Οι εντολές δεν μπόρεσαν να φορτωθούν.',
  commands_range_hint: 'Επιτρεπτό: {{min}}–{{max}}',

  /*
   * |=============|
   * | Copy Config |
   * |=============|
   */

  // Page
  copy_config_copy_config: 'Αντιγραφή διαμόρφωσης',
  copy_config_to_device_number_with_name_absent: 'Στη συσκευή: {{device_number}}',
  copy_config_to_device_number_with_name_present:
    'Στη συσκευή: {{device_name}} ({{device_number}})',
  copy_config_from_device_number: 'Από τον αριθμό συσκευής',
  copy_config_copy_config_type_label: 'Τύπος αντιγραφής διαμόρφωσης',
  copy_config_existing_device_option: 'Υπάρχουσα συσκευή',
  copy_config_new_device_option: 'Νέα συσκευή',
  copy_config_should_copy_label: 'Πρέπει να αντιγραφεί:',
  copy_config_should_copy_config_option: 'Διαμόρφωση',
  copy_config_should_copy_value_ranges_option: 'Εύρη τιμών',

  // Buttons
  copy_config_btn_copy: 'αντίγραφο',

  //Toast
  copy_config_toast_copied_success: 'Η διαμόρφωση συσκευής αντιγράφηκε με επιτυχία.',
  copy_config_toast_copied_error:
    'Υπήρξε πρόβλημα κατά την προσπάθεια αντιγραφής της διαμόρφωσης της συσκευής.',
  copy_config_value_ranges_toast_copied_success: 'Τα εύρη τιμών αντιγράφηκαν με επιτυχία.',
  copy_config_value_ranges_toast_copied_error:
    'Υπήρξε πρόβλημα κατά την προσπάθεια αντιγραφής των εύρων τιμών.',

  /*
   * |============|
   * | Statistics |
   * |============|
   */
  statistics_header: 'Στατιστική',
  statistics_header_hours: 'Ωρες',
  statistics_header_quantity: 'Ποσότητα',
  statistics_header_value: 'αξία',
  statistics_quantity_minimum: 'Ελάχιστο',
  statistics_quantity_maximum: 'Το πολύ',
  statistics_quantity_average: 'Μέση τιμή',
  statistics_quantity_total: 'Σύνολο',
  statistics_quantity_hours: 'Ωρες',
  statistics_quantity_counters: 'Μετρητές',
  statistics_error_title: 'Τα στατιστικά δεν είναι διαθέσιμα',
  statistics_error_missing_config_title: 'Η ρύθμιση του υδρομετρητή είναι ελλιπής',
  statistics_error_missing_config_description:
    'Για να υπολογιστούν τα στατιστικά, οι τιμές diameter, q3 και r πρέπει να είναι ορισμένες για κάθε υδρομετρητή. Ελέγξτε τις τρέχουσες τιμές παρακάτω και συμπληρώστε όσες λείπουν.',
  statistics_error_missing_field: 'Λείπει το {{field}}',
  statistics_error_not_defined: 'Δεν έχει οριστεί',
  statistics_error_open_sensor_config: 'Άνοιγμα ρύθμισης αισθητήρα',
  statistics_error_update_values_hint:
    'Συμπληρώστε τις τιμές που λείπουν και επιστρέψτε σε αυτή τη σελίδα.',
  statistics_error_contact_admin:
    'Επικοινωνήστε με έναν διαχειριστή και ζητήστε του να ορίσει τις τιμές ρύθμισης που λείπουν για τον υδρομετρητή.',
  statistics_error_flow_unit_not_configured:
    'Ο επιλεγμένος αισθητήρας δεν έχει ρυθμισμένη μονάδα ροής.',

  // Error
  statistics_error_definition_for_q3:
    'Ο αισθητήρας {{name}} περιέχει έναν ορισμό για το q3. Επισκεφθείτε τη σελίδα διαμόρφωσης αισθητήρα.',
  statistics_eror_definition_for_diameter:
    'Ο αισθητήρας {{name}} περιέχει έναν ορισμό για τη διάμετρο. Επισκεφθείτε τη σελίδα διαμόρφωσης αισθητήρα.',
  statistics_error_definition_for_r:
    'Ο αισθητήρας {{name}} περιέχει έναν ορισμό για το r. Επισκεφθείτε τη σελίδα διαμόρφωσης αισθητήρα.',
  statistics_error_no_water_meters_found:
    'Δεν βρέθηκαν μετρητές νερού. Επισκεφθείτε τη σελίδα διαμόρφωσης της συσκευής.',

  /*
   * |=====|
   * | Map |
   * |=====|
   */
  map_add_device: 'Προσθήκη {{device}}',
  map_edit_device: 'Επεξεργασία {{device}}',
  map_lat: 'Γεωγραφικό πλάτος',
  map_long: 'Γεωγραφικό μήκος',
  map_coordinates: 'Συντεταγμένες',
  map_polygon: 'Πολύγωνο',
  map_linked_in_polygons: 'Περιέχεται σε πολύγωνα:',
  map_loading: 'Φόρτωση...',

  // Button
  map_btn_link_device: 'Σύνδεση συσκευής',
  map_btn_submit: 'Υποβάλλουν',

  // Error
  map_err_add_device_to_map: 'Δεν ήταν δυνατή η προσθήκη της συσκευής στον χάρτη.',
  map_err_change_location: 'Δεν ήταν δυνατή η αλλαγή τοποθεσίας.',
  map_err_link_polygon: 'Δεν ήταν δυνατή η σύνδεση με το πολύγωνο.',

  // Device Modal
  map_btn_get_curr_location: 'Πάρτε την τρέχουσα τοποθεσία',
  map_geolocation_not_supported: 'Η γεωτοποθεσία δεν υποστηρίζεται από αυτόν τον περιηγητή.',
  map_lat_validation_message: 'Μη έγκυρο γεωγραφικό πλάτος',
  map_long_validation_message: 'Μη έγκυρο γεωγραφικό μήκος',
  map_invalid_location: 'Μη έγκυρη τοποθεσία',
  map_invalid_coordinate_input:
    'Μη έγκυρη εισαγωγή συντεταγμένων. Θα πρέπει να είναι «lat, long», π.χ. 42.123, 23.123',

  // Set Coordinates Modal
  map_coordinates_modal_btn_label: 'Ορισμός Συντεταγμένων',
  map_coordinates_modal_title: 'Ορισμός Συντεταγμένων',
  map_coordinates_modal_target_option_self: 'Για Εαυτόν',
  map_coordinates_modal_target_option_company: 'Για την Εταιρεία',
  map_coordinates_modal_target_option_user: 'Για τον Χρήστη',
  map_coordinates_modal_select_user_autocomplete_label: 'Όνομα Χρήστη',
  map_coordinates_modal_save_for_self_warning_message:
    'Η αποθήκευση θα ορίσει τις τρέχουσες συντεταγμένες ως προεπιλογή για τον τρέχοντα χρήστη σας. Είστε σίγουροι ότι θέλετε να συνεχίσετε;',
  map_coordinates_modal_save_for_company_warning_message:
    'Η αποθήκευση θα ορίσει τις τρέχουσες συντεταγμένες ως προεπιλογή για κάθε χρήστη στην εταιρεία σας. Είστε σίγουροι ότι θέλετε να συνεχίσετε;',
  map_coordinates_modal_save_for_user_warning_message:
    'Η αποθήκευση θα ορίσει τις τρέχουσες συντεταγμένες ως προεπιλογή για τον επιλεγμένο χρήστη. Είστε σίγουροι ότι θέλετε να συνεχίσετε;',
  map_coordinates_modal_confirm_btn_label: 'Επιβεβαίωση',
  map_coordinates_modal_cancel_btn_label: 'Ακύρωση',

  /*
   * |===============|
   * | Sensor Config |
   * |===============|
   */

  flow_time_units: 'Μονάδα χρόνου',
  flow_measurement_units: 'Μονάδα μέτρησης',
  flow_configuration_label: 'Διαμόρφωση ροής',
  flow_coefficient: 'Συντελεστής',
  sensor_config_sensor_group_name: 'Όνομα ομάδας αισθητήρων',
  flow_configuration_alert_message: 'Ελέγξτε τις ακόλουθες διαμορφώσεις ροής:\n{{message}}',
  flow_configuration_invalid_sensor_row_message:
    'Ευρετήριο: {{sensor_index}} με όνομα: {{sensor_name}}\n',
  flow_configuration_sensor_name_not_set_label: 'Δεν ρυθμίστηκε',

  /*
   * |===================|
   * | Device Prediction |
   * |===================|
   */
  device_prediction: 'Πρόβλεψη συσκευής',
  device_prediction_header: 'Ανάλυση χρονοσειρών',
  device_prediction_sensor_name: 'Όνομα Αισθητήρα',
  device_prediction_forward_days: 'Ημέρες πρόβλεψης',
  device_prediction_backward_days: 'Ημέρες επιστροφής',
  device_prediction_generate_btn: 'Δημιουργία',
  device_prediction_error: 'Σφάλμα',
  device_prediction_error_msg_json: 'Παρουσιάστηκε πρόβλημα με τη δημιουργία δεδομένων πρόβλεψης',
  device_prediction_error_msg_image:
    'Παρουσιάστηκε πρόβλημα με τη δημιουργία της εικόνας πρόβλεψης',
  device_prediction_date: 'Ημερομηνία',
  device_prediction_trend: 'Τάση',
  device_prediction_time: 'Ώρα',
  device_prediction_legend_prediction: 'Πρόβλεψη',
  device_prediction_legend_range: 'Περιοχή πρόβλεψης',
  device_prediction_legend_consumption: 'Τρέχουσα κατανάλωση',
  device_prediction_help_title: 'Βοήθεια',
  device_prediction_help_title_input_guide: 'Οδηγός Εισαγωγής',
  device_prediction_help_input_guide_text:
    '<strong> 1. Περίοδος </strong> - Οι χρήστες μπορούν να επιλέξουν ένα εύρος ημερομηνιών από προκαθορισμένες επιλογές ή να ορίσουν ένα προσαρμοσμένο εύρος. Το σύστημα αναλύει τα δεδομένα εντός αυτής της επιλεγμένης περιόδου για να υπολογίσει μελλοντικές προβλέψεις, προσφέροντας πολύτιμες γνώσεις. <br> <strong> 2. Όνομα Αισθητήρα </strong> – επιλέξτε τον αισθητήρα από τον οποίο θέλετε να δείτε τις μελλοντικές προβλέψεις. <br> <strong> 3. Κάθε </strong> - χρησιμοποιείται για πιο λεπτομερείς προβλέψεις όσον αφορά την κλίμακα του χρόνου. <br> <strong> 4. Μέρες Προς τα Εμπρός </strong> - αριθμός ημερών που ο χρήστης επιθυμεί να προβλέψει στο μέλλον. Αυτές οι προβλέψεις εκτείνονται πέρα ​​από την επιλεγμένη περίοδο, παρέχοντας εισαγωγές για την αναμενόμενη συμπεριφορά κατανάλωσης. <br> <strong> 5. Μέρες Προς τα Πίσω </strong> - αντιπροσωπεύει τον αριθμό των ημερών που θα εμφανιστούν στο γράφημα και στον πίνακα, ξεκινώντας από την τελευταία ημέρα της επιλεγμένης περιόδου. Αυτό επιδεικνύει τα ιστορικά πραγματικά δεδομένα που λήφθηκαν από τη συσκευή κατά τη διάρκεια αυτής της συγκεκριμένης περιόδου. <br> <strong> 6. Κουμπί "Δημιουργία" </strong> – κάνοντας κλικ στο "Δημιουργία", το σύστημα υπολογίζει την κατανάλωση βάσει των επιλεγμένων ρυθμίσεων και δημιουργεί προβλέψεις. Τα αποτελέσματα εμφανίζονται τόσο στην Προβολή Γραφημάτων όσο και στην Προβολή Πίνακα. <br> <strong> 7. Γράφημα </strong> – Το γράφημα εμφανίζει τόσο τις μέρες προς τα εμπρός όσο και τις μέρες προς τα πίσω, παρουσιάζοντας τα πραγματικά ληφθέντα δεδομένα και εμφανίζοντας τα προβλεπόμενα δεδομένα. <br> <strong> 8. Πίνακας </strong> - Ο πίνακας εμφανίζει όλα τα δεδομένα από το "από την περίοδο" έως το τέλος των "μερών προς τα εμπρός". Κάθε σειρά περιλαμβάνει μια συγκεκριμένη ημερομηνία, ώρα και αντίστοιχη τιμή τάσης, που υποδηλώνει τη γενική κατεύθυνση ή το μοτίβο των δεδομένων κατά τη διάρκεια του χρόνου. Βοηθά στην κατανόηση εάν οι τιμές αυξάνονται, μειώνονται ή παραμένουν σταθερές κατά την προβλεπόμενη περίοδο.',
  device_prediction_help_title_legend: 'Λεζάντα',
  device_prediction_help_black:
    '<strong> Μαύρο Χρώμα </strong> - αναπαριστά τα πραγματικά δεδομένα κατανάλωσης κατά τη διάρκεια της επιλεγμένης περιόδου (παράδειγμα: από 01 Ιουλίου έως 31 Ιουλίου).',
  device_prediction_help_red:
    '<strong> Κόκκινο Χρώμα </strong> - Αναπαριστά την πραγματική κατανάλωση εάν υπάρχουν δεδομένα εκτός της επιλεγμένης περιόδου. Στην παραπάνω εικόνα υπάρχουν πραγματικά δεδομένα που λήφθηκαν από τη συσκευή στις ημέρες που το μοντέλο είναι ρυθμισμένο να κάνει προβλέψεις. Έτσι, ο χρήστης μπορεί να συγκρίνει τις προβλεπόμενες τιμές (σκούρο μπλε) με τις κόκκινες (πραγματικά δεδομένα).',
  device_prediction_help_dark_blue:
    ' <strong> Σκούρο Μπλε Χρώμα </strong> - Αναπαριστά την πρόβλεψη για την επιλεγμένη περίοδο, που περιλαμβάνει παλιά δεδομένα και εκτείνεται προς το μέλλον με τις προβλεπόμενες τιμές των μερών προς τα εμπρός. Αυτές οι προβλεπόμενες τιμές παρέχουν εισαγωγές για την αναμενόμενη τάση κατανάλωσης.',
  device_prediction_help_light_blue:
    '<strong> Ανοιχτό Μπλε Χρώμα </strong> - Αναπαριστά την περιοχή των προβλεπόμενων τιμών. Υποδηλώνει ότι τα πραγματικά δεδομένα κατανάλωσης μπορεί να βρίσκονται εντός αυτής της περιοχής, υποδεικνύοντας την αβεβαιότητα που συνδέεται με τις προβλέψεις.',

  device_prediction_help_example:
    "Εάν η ημερομηνία 'ΑΠΟ' οριστεί στην 1η Ιουλίου και η ημερομηνία 'ΜΕΧΡΙ' στην 31η Ιουλίου, με 'Μέρες προς τα εμπρός' 30, 'Μέρες προς τα πίσω' 30 και 'ΚΑΘΕ' 10 λεπτά, το γράφημα θα εμφανίσει την πραγματική κατανάλωση των 30 ημερών διαθέσιμη (από την 1η Ιουλίου έως την 1η Αυγούστου) και τις προβλεπόμενες τιμές για 30 μέρες προς τα εμπρός (από την 1η Αυγούστου έως την 1η Σεπτεμβρίου). Ο πίνακας θα εμφανίσει την πραγματική και προβλεπόμενη κατανάλωση για κάθε διάστημα των 10 λεπτών από την 1η Ιουλίου έως την 1η Σεπτεμβρίου 2023.",

  /*
   * |=================|
   * | Counters Export |
   * |=================|
   */

  // Buttons and dropdowns
  counters_export_header: 'Εξαγωγή δεδομένων',
  counters_readings_header: 'Αναφορές',
  counters_export_search: 'Αναζήτηση',
  counters_export_download: 'Κατεβάστε',
  counters_export_format: 'Μορφή',

  // Table columns
  counters_export_table_device_name: 'Όνομα συσκευής',
  counters_export_table_device_number: 'Αριθμός συσκευής',
  counters_export_table_sensor_index: 'Δείκτης αισθητήρα',
  counters_export_table_sensor_name: 'Όνομα αισθητήρα',
  counters_export_table_date: 'Ημερομηνία',
  counters_export_table_counters: 'Τιμή',
  counters_export_table_prev_counters: 'Προηγούμενη τιμή',
  counters_export_table_dt: 'Χρονική διαφορά',
  counters_export_table_delta: 'Διαφορά',
  counters_export_error_alert_message: 'Παρουσιάστηκε σφάλμα κατά τη δημιουργία των δεδομένων.',
  counter_export_select_devices_label: 'Επιλέξτε συσκευές',
  counter_export_select_sensors_label: 'Επιλέξτε αισθητήρες',
  counter_export_sensor_index: 'Δείκτης αισθητήρα: {{sensor_index}}',

  counters_export_maximum_capacity_error_message: 'Συμπληρώθηκε η μέγιστη χωρητικότητα εξαγωγής!',
  counters_export_maximum_capacity_suggestion_message:
    'Μειώστε τον αριθμό των επιλεγμένων συσκευών ή την περίοδο ημερομηνίας.',
  counters_export_empty_selection_title: 'Επιλέξτε τι θα εξαχθεί',
  counters_export_empty_selection_message:
    'Επιλέξτε μία ή περισσότερες συσκευές ή ομάδες συσκευών για να προετοιμάσετε την εξαγωγή μετρήσεων.',
  counters_export_ready_title: 'Η επιλογή είναι έτοιμη',
  counters_export_ready_message:
    'Έχουν επιλεγεί {{devicesCount}} συσκευές και {{groupsCount}} ομάδες συσκευών. Πατήστε Αναζήτηση για προεπισκόπηση των δεδομένων ή Λήψη για εξαγωγή.',
  counters_export_selected_device_toast: 'Επιλεγμένη συσκευή: {{deviceNumber}}',
  /*
   * |====================|
   * | Consumption Export |
   * |====================|
   */

  // Buttons and dropdowns
  consumption_export_header: 'Έκθεση',
  consumption_export_search: 'Αναζήτηση',
  consumption_export_download: 'Κατεβάστε',
  consumption_export_format: 'Μορφή',
  consumption_export_aggregation_period: 'Περίοδος Συγκέντρωσης',
  consumption_export_aggregation_options_none: 'Κανένα',
  consumption_export_aggregation_options_daily: 'Ημερήσιος',
  consumption_export_aggregation_options_weekly: 'Εβδομαδιαίος',
  consumption_export_aggregation_options_monthly: 'Μηνιαίος',
  consumption_export_aggregation_options_yearly: 'Ετήσιος',

  // Table columns
  consumption_export_table_device_number: 'Αριθμός συσκευής',
  consumption_export_table_sensor_index: 'Δείκτης αισθητήρα',
  consumption_export_table_address: 'Διεύθυνση',
  consumption_export_table_sensor_name: 'Όνομα αισθητήρα',
  consumption_export_table_first_reading_date: 'Ημερομηνία πρώτης τιμής',
  consumption_export_table_first_reading_value: 'Πρώτη τιμή',
  consumption_export_table_last_reading_date: 'Ημερομηνία τελευταίας τιμής',
  consumption_export_table_last_reading_value: 'Τελευταία τιμή',
  consumption_export_table_delta: 'Διαφορά',
  consumption_export_table_average: 'Μέσος όρος',
  consumption_export_table_consumption_for_period: 'Κατανάλωση για την περίοδο',
  consumption_export_empty_selection_title: 'Επιλέξτε τι θα εξαχθεί',
  consumption_export_empty_selection_message:
    'Επιλέξτε μία ή περισσότερες συσκευές ή ομάδες συσκευών για να προετοιμάσετε την εξαγωγή κατανάλωσης.',
  consumption_export_ready_title: 'Η επιλογή είναι έτοιμη',
  consumption_export_ready_message:
    'Έχουν επιλεγεί {{devicesCount}} συσκευές και {{groupsCount}} ομάδες συσκευών. Πατήστε Αναζήτηση για προεπισκόπηση των δεδομένων ή Λήψη για εξαγωγή.',
  consumption_export_selected_device_toast: 'Επιλεγμένη συσκευή: {{deviceNumber}}',

  /*
   * |=================|
   * | Alarms Export |
   * |=================|
   */

  // Buttons and dropdowns
  alarms_export_header: 'Συναγερμός',
  alarms_export_search: 'Αναζήτηση',
  alarms_export_refresh: 'Ενημερώνω',
  alarms_export_download: 'Κατεβάστε',
  alarms_export_format: 'Μορφή',

  alarms_return_to_alarms: 'Επιστροφή στους Συναγερμούς',
  alarms_redirect_to_graph: 'Ανακατεύθυνση στο Γράφημα',

  // Table columns
  alarms_export_table_date: 'Ημερομηνία',
  alarms_export_table_device_number: 'Αριθμός συσκευής',
  alarms_export_table_device_name: 'Ονομα της συσκευής',
  alarms_export_table_severity: 'Σοβαρότητα',
  alarm_severity_tooltip: 'Σοβαρότητα: {{value}} από 10',
  alarm_severity_none_tooltip: 'Δεν αναφέρθηκε σοβαρότητα για αυτόν τον συναγερμό',
  alarms_export_table_sensor_index: 'Δείκτης αισθητήρα',
  alarms_export_table_sensor_name: 'Όνομα αισθητήρα',
  alarms_export_table_alarm_type: 'Τύπος',
  alarms_export_table_alarm_status: 'Κατάσταση',
  alarms_export_table_description: 'Περιγραφή',
  alarms_export_table_link_to_graph: 'Σύνδεσμος προς το γράφημα',
  alarms_export_chip_status_active: 'Ενεργός',
  alarms_export_chip_status_inactive: 'Αδρανής',
  alarms_export_switch_title_label: 'Αυτόματη ανανέωση',
  alarms_export_error_alert_message: 'Παρουσιάστηκε σφάλμα κατά τη δημιουργία των δεδομένων.',
  alarms_export_select_company_alert_message: 'Επιλέξτε μια εταιρεία πριν λάβετε συναγερμούς',
  alarms_export_select_device_or_company_alert_message:
    'Επιλέξτε μια συσκευή ή εταιρεία πριν από τη λήψη ξυπνητηρίων',
  alarms_export_error_too_big_query:
    'Η ανάκτηση ιστορικού από το Σούπερ Διαχειριστής για όλες τις συσκευές είναι πολύ μεγάλο αίτημα. Επιλέξτε μια εταιρεία.',

  /*
   * |================|
   * | Inventory page |
   * |================|
   */

  //table
  device_inventory_page_header: 'Απόθεμα',
  device_inventory_column_header_search: 'Αναζήτηση...',
  device_inventory_description: 'Περιγραφή',
  device_inventory_device_name: 'Όνομα Συσκευής',
  device_inventory_device_number: 'Αριθμός Συσκευής',
  device_inventory_hardware_version: 'Έκδοση Υλικού',
  device_inventory_model: 'Μοντέλο',
  device_inventory_software_version: 'Έκδοση Λογισμικού',
  device_inventory_actions: 'Ενέργειες',
  nomenclature: 'Ονοματολογία',

  //modal
  device_inventory_manual: 'Ρυθμιστικό',
  device_inventory_template: 'Πρότυπο',
  device_inventory_add_device: 'Προσθήκη Συσκευής',
  device_inventory_create_device_button: 'Δημιουργία Συσκευής',
  device_inventory_delete_unlink_modal_body:
    'Αυτό θα διαγράψει μόνιμα τη συσκευή που επιλέξατε ή μπορείτε να την αποσυνδέσετε από την επιλεγμένη εταιρεία. Η συσκευή θα αποσυνδεθεί από τον τρέχοντα λογαριασμό και όλους τους υπολογαριασμούς. Αν θέλετε να αποσυνδέσετε τη συσκευή μόνο από τον τρέχοντα λογαριασμό, παρακαλώ μεταβείτε στη σελίδα "Σύνδεση συσκευής".',
  device_inventory_delete_modal_body: 'Αυτό θα διαγράψει μόνιμα την επιλεγμένη συσκευή.',
  device_inventory_hardware_version_helper:
    'Ο απαιτούμενος μορφότυπος είναι X.X.X, όπου το X είναι ένας αριθμός',
  device_inventory_update_device_button: 'Ενημέρωση Συσκευής',
  device_inventory_update_device_title: 'Ενημέρωση {{number}}',
  device_inventory_modal_delete_device_title: 'Διαγραφή συσκευής {{number}}',
  device_inventory_software_version_helper:
    'Ο απαιτούμενος μορφότυπος είναι X.X.X ή X.X.X- και X.X.X_ ακολουθούμενο από χαρακτήρες, όπου το X είναι ένας αριθμός',
  device_inventory_description_helper: 'Έχετε φτάσει το όριο μήκους περιγραφής',
  device_inventory_device_number_helper:
    'Παρακαλώ εισάγετε 8 χαρακτήρες που περιέχουν μόνο γράμματα (A-Z) και αριθμούς (0-9).',
  device_inventory_modal_select_action: 'Επιλέξτε δράση για τη συσκευή {{deviceNumber}}',
  device_inventory_reference_device_number: 'Επιλέξτε συσκευή για αναφορά',
  device_inventory_nomenclature_required_for_model:
    'Η ονοματολογία είναι υποχρεωτική για το {{model}}',

  //success
  device_inventory_create_device_success: 'Η συσκευή δημιουργήθηκε με επιτυχία',
  device_inventory_update_device_success: 'Η συσκευή ενημερώθηκε με επιτυχία',
  device_inventory_delete_device_success: 'Η συσκευή διαγράφηκε με επιτυχία',
  device_inventory_unlink_device_success: 'Η συσκευή αποσυνδέθηκε επιτυχώς',
  device_inventory_rma_add_success: 'Η εγγραφή RMA προστέθηκε επιτυχώς',
  device_inventory_rma_history_title: 'Ιστορικό RMA - {{number}}',
  device_inventory_rma_add_record: 'Προσθήκη εγγραφής',
  device_inventory_rma_no_records: 'Δεν υπάρχουν εγγραφές RMA για αυτήν τη συσκευή',
  device_inventory_rma_add_error: 'Παρουσιάστηκε σφάλμα κατά την προσθήκη της εγγραφής RMA',
  rma_record_date: 'Ημερομηνία',
  rma_record_date_required: 'Η ημερομηνία είναι υποχρεωτική',
  rma_record_type: 'Τύπος',
  rma_record_category: 'Κατηγορία',
  rma_record_comments: 'Σχόλια',
  rma_record_save: 'Αποθήκευση',
  rma_record_back: 'Πίσω',
  rma_type_INCIDENT: 'Συμβάν',
  rma_type_DEVICE_EVENT: 'Συμβάν συσκευής',
  rma_type_RMA: 'RMA',
  rma_category_BATTERY_REPLACEMENT: 'Αντικατάσταση μπαταρίας',
  rma_category_SIM_CARD_CHANGE: 'Αλλαγή κάρτας SIM',
  rma_category_ENCLOSURE_DEGRADATION: 'Φθορά περιβλήματος',
  rma_category_FLOOD_DAMAGE: 'Ζημιά από πλημμύρα',
  rma_category_ANTENNA_REPLACEMENT: 'Αντικατάσταση κεραίας',
  rma_category_POWER_SUPPLY_PROBLEM: 'Πρόβλημα τροφοδοσίας',
  rma_category_PHYSICAL_DAMAGE: 'Φυσική ζημιά',
  rma_category_STOLEN: 'Κλεμμένο',
  rma_category_WRONG_CONFIGURATION: 'Λανθασμένη διαμόρφωση',
  rma_category_OTHER: 'Άλλο',

  //error
  device_inventory_create_device_error: 'Προέκυψε σφάλμα κατά τη δημιουργία συσκευής',
  device_inventory_delete_device_error: 'Προέκυψε σφάλμα κατά τη διαγραφή συσκευής',
  device_inventory_device_exists: 'Η συσκευή υπάρχει ήδη',
  device_inventory_empty_device_error: 'Ο αριθμός συσκευής δεν μπορεί να είναι κενός',
  device_inventory_empty_reference_error: 'Επιλέξτε συσκευή για αναφορά',
  device_inventory_empty_device_name_error: 'Το όνομα της συσκευής δεν μπορεί να είναι κενό',
  device_inventory_empty_hardware_error: 'Η έκδοση υλικού δεν μπορεί να είναι κενή',
  device_inventory_empty_software_error: 'Η έκδοση λογισμικού δεν μπορεί να είναι κενή',
  device_inventory_error: 'Δεν ήταν δυνατή η φόρτωση των συσκευών',
  device_inventory_update_device_error: 'Προέκυψε σφάλμα κατά την ενημέρωση της συσκευής',
  device_inventory_already_exists_error: 'Η συσκευή με αυτόν τον αριθμό υπάρχει ήδη',
  device_inventory_empty_nomenclature_error: 'Η ονοματολογία δεν μπορεί να είναι κενή',
  device_inventory_empty_manufacturing_date_error:
    'Η ημερομηνία κατασκευής δεν μπορεί να είναι κενή',
  device_inventory_empty_warranty_period_error: 'Η περίοδος εγγύησης δεν μπορεί να είναι κενή',

  /*
   * |====================|
   * | Transmissions page |
   * |====================|
   */

  //page
  transmissions_page_title: 'Μεταδόσεις',
  transmissions_page_refresh: 'Ανανέωση',
  transmissions_page_export_csv: 'Εξαγωγή σε CSV',
  transmissions_page_error_message: 'Δεν μπόρεσε να φορτώσει μεταδόσεις',

  //table
  transmissions_table_device_number: 'Αριθμός συσκευής',
  transmissions_table_device_name: 'Όνομα συσκευής',
  transmissions_table_last_transmission: 'Τελευταία μετάδοση',
  transmissions_table_next_transmission: 'Επόμενη μετάδοση',
  transmissions_table_days: 'Ημέρες',
  transmissions_table_transmission: 'Μετάδοση',
  transmissions_table_count: 'Ποσότητα',
  transmissions_table_customer: 'Πελάτης',
  transmissions_table_address: 'Διεύθυνση',
  transmissions_table_ok: 'OK',
  transmissions_table_devEUI: 'devEUI',
  transmissions_table_simcard_number: 'Αριθμός κάρτας Sim',
  transmissions_table_simcard_provider: 'Πάροχος κάρτας Sim',
  transmissions_table_apn: 'APN',

  /*
   * |===============|
   * | Device Config |
   * |===============|
   */

  // page
  device_config_period: 'Περίοδος',
  device_config_every: 'Κάθε',

  // error
  device_config_error_record_period_postiive: 'Η περίοδος ρεκόρ πρέπει να είναι θετική.',
  device_config_error_transmission_period_positive: 'Η περίοδος μετάδοσης πρέπει να είναι θετική.',
  device_config_error_record_must_be_greater_than_transmission:
    'Η περίοδος εγγραφής δεν μπορεί να είναι μεγαλύτερη από την περίοδο μετάδοσης.',
  device_config_error_not_divisible: 'Η περίοδος εγγραφής δεν διαιρείται με την περίοδο μετάδοσης.',
  device_config_error_max_threshold_reached:
    'Οι εγγραφές {{curr}} ανά μετάδοση είναι περισσότερες από το μέγιστο {{max}}.',

  /*
   * |=======|
   * | Graph |
   * |=======|
   */
  graph_tabs_readings: 'Τιμές',
  graph_tabs_prediction: 'Πρόβλεψη',
  graph_tabs_average: 'Μέσος όρος',
  graph_tabs_previous: 'Προηγούμενος',
  graph_column_sensor: 'Αισθητήρας',
  graph_column_index: 'Ευρετήριο',
  graph_column_device: 'Συσκευή',
  graph_column_device_name: 'Όνομα συσκευής',
  graph_column_date: 'Ημερομηνία',
  graph_column_readings: 'Τιμή',
  graph_column_previous_readings: 'Προηγούμενη τιμή',
  graph_column_delta: 'Διαφορά',
  /*
   * |===============|
   * | Settings page |
   * |===============|
   */
  settings_page_header: 'Ρυθμίσεις',
  settings_submit_success_msg: 'Οι ρυθμίσεις αποθηκεύτηκαν',
  settings_submit_error_msg: 'Οι ρυθμίσεις δεν μπόρεσαν να αποθηκευτούν',
  settings_input_invalid_format_error_msg: 'Μη έγκυρη μορφή δεδομένων',
  settings_certificate_not_found_error: 'Δεν βρέθηκε πιστοποιητικό σε αυτήν τη διαδρομή αρχείου',
  settings_add_button: 'Προσθήκη',
  settings_submit_button: 'Υποβολή',
  settings_input_key_label: 'Κλειδί',
  settings_input_type_label: 'Τύπος',
  settings_input_value_label: 'Τιμή',
  settings_select_type_string: 'Συμβολοσειρά',
  settings_select_type_number: 'Número',
  settings_select_type_boolean: 'Δυαδικός',
  settings_select_type_object: 'Αντικείμενο',
  settings_logo_label: 'Logo',
  settings_dashboard_layout_label: 'Διάταξη του πίνακα ελέγχου',
  settings_certificate_label: 'Διαδρομή πιστοποιητικού',
  settings_device_panel_title: 'Τίτλος πίνακα συσκευής',
  settings_sensor_panel_title: 'Τίτλος πίνακα αισθητήρα',
  settings_header_home_label: 'Ετικέτα Αρχικής Σελίδας (Portal)',
  settings_header_dashboard_label: 'Ετικέτα Πίνακα Ελέγχου (Portal)',
  settings_footer_main_label: 'Κύρια Ετικέτα Υποσέλιδου (Portal)',
  settings_footer_link_label: 'Ετικέτα Συνδέσμου Υποσέλιδου (Portal)',
  settings_footer_link_url: 'URL Συνδέσμου Υποσέλιδου (Portal)',
  settings_alarm_notification_display_period:
    'Περίοδος εμφάνισης ειδοποιήσεων συναγερμών (ώρες) (Portal)',

  /* |===========|
   * | New Graph |
   * |===========|
   */

  //page
  new_graph_add_device_group_modal_title: 'Διαμόρφωση αισθητήρων ομάδας συσκευών "Κάθε"',
  new_graph_add_device_group_modal_device_group: 'Ομάδα συσκευών: ',
  new_graph_add_device_group_modal_sensors_to_add: 'Αισθητήρες για προσθήκη: ',
  new_graph_add_device_group_modal_every_selector_mode_per_device: 'Ανά συσκευή',
  new_graph_add_device_group_modal_every_selector_mode_per_sensor: 'Ανά αισθητήρα',
  new_graph_add_device_group_modal_sensor_limit_message:
    'Δεν μπορείτε να υπερβείτε το όριο του γραφήματος των {{graphSensorsLimit}} αισθητήρων!',
  new_graph_add_device_group_modal_confirm_button: 'Επιβεβαίωση',
  new_graph_add_device_group_modal_cancel_button: 'Ακύρωση',
  new_graph_select_sensor_heading: 'Επιλέξτε Αισθητήρας',
  new_graph_date_range_selection: 'Επιλογή εύρους ημερομηνιών',
  new_graph_selected_sensors_heading: 'Επιλεγμένοι αισθητήρες',
  new_graph_selected_sensors_remove_all_tooltip: 'Εκκαθάριση όλων',
  new_graph_select_company_message: 'Επιλέξτε μια εταιρεία',
  new_graph_show_sensors_statistics_label: 'Εμφάνιση στατιστικών στοιχείων',

  //sensor selection
  new_graph_device_group_label: 'Ομάδα συσκευών',
  new_graph_device_label: 'Συσκευή',
  new_graph_sensor_label: 'Αισθητήρας',

  //date range selection
  new_graph_average_days_label: 'Μέσος όρος ημερών',
  new_graph_time_series_prediction_period_label: 'Περίοδος',
  new_graph_auto_refresh_label: 'Ανανέωση',
  new_graph_period_picker_heading: 'Περίοδος',
  new_graph_average_days_heading: 'Μέση τιμή',
  new_graph_time_series_prediction_period_heading: 'Πρόβλεψη χρονοσειρών',
  new_graph_none_option: 'Κανένας',
  new_graph_day_option_one: '{{count}} ημέρα',
  new_graph_day_option_other: '{{count}} ημέρες',
  new_graph_week_option_one: '{{count}} εβδομάδα',
  new_graph_week_option_other: '{{count}} εβδομάδες',
  new_graph_month_option_one: '{{count}} μήνας',
  new_graph_month_option_other: '{{count}} μήνες',
  new_graph_year_option_one: '{{count}} χρόνος',
  new_graph_year_option_other: '{{count}} χρόνια',

  //tooltip
  new_graph_current_value_name: 'Τρέχουσα',
  new_graph_average_value_name: 'Μέση',
  new_graph_prediction_value_name: 'Πρόβλεψη',

  //error
  new_graph_fetch_device_groups_error:
    'Δεν ήταν δυνατή η φόρτωση των ομάδων συσκευών για την εταιρεία.',
  new_graph_fetch_devices_error: 'Δεν ήταν δυνατή η φόρτωση των συσκευών για την εταιρεία.',
  new_graph_fetch_device_config_error:
    'Δεν ήταν δυνατή η φόρτωση της διαμόρφωσης της επιλεγμένης συσκευής.',
  new_graph_fetch_device_ports_config_error:
    'Δεν ήταν δυνατή η φόρτωση των θυρών για την επιλεγμένη συσκευή.',
  new_graph_fetch_device_flow_error:
    'Δεν ήταν δυνατή η φόρτωση της ροής για τη συσκευή {{deviceName}}.',
  new_graph_fetch_device_flow_avg_error:
    'Δεν ήταν δυνατή η φόρτωση της μέσης ροής για τη συσκευή {{deviceName}}.',
  new_graph_fetch_device_readings_error:
    'Δεν ήταν δυνατή η φόρτωση των αναγνώσεων για τη συσκευή {{deviceName}}.',
  new_graph_fetch_device_readings_avg_error:
    'Δεν ήταν δυνατή η φόρτωση των μέσων αναγνώσεων για τη συσκευή {{deviceName}}.',
  new_graph_fetch_device_on_off_alarms_error:
    'Δεν ήταν δυνατή η φόρτωση των ειδοποιήσεων ενεργοποίησης/απενεργοποίησης για τη συσκευή {{deviceName}}.',
  new_graph_fetch_device_prediction_error:
    'Δεν ήταν δυνατό να φορτωθεί η πρόβλεψη για {{deviceName}}.',
  new_graph_sensor_already_in_state_error:
    'Ο συγκεκριμένος αισθητήρας έχει ήδη προστεθεί στη λίστα.',

  /* |================|
   * | Billing Report |
   * |================|
   */

  billing_report_header: 'Έκθεση χρέωσης',
  billing_report_btn_generate: 'Δημιουργία',
  billing_report_device_number: 'Αριθμός συσκευής',
  billing_report_first_reading_date: 'Ημερομηνία πρώτης ανάγνωσης',
  billing_report_last_reading_date: 'Ημερομηνία τελευταίας ανάγνωσης',
  billing_report_readings: 'Αναγνώσεις',
  billing_report_battery: 'Μπαταρία',
  billing_report_signal: 'Σήμα',
  billing_report_total: 'Σύνολο',

  /* |================|
   * | Profile Page   |
   * |================|
   */
  profile_page_change_logo: 'Αλλαγή λογότυπου',
  profile_page_logo_formats_message: 'Αποδεκτές μορφές: PNG, JPEG',
  profile_page_name: 'Όνομα',
  profile_page_email: 'Email',
  profile_page_password: 'Κωδικός πρόσβασης',
  profile_page_language: 'Γλώσσα',
  profile_page_change_language: 'Αλλαγή γλώσσας',
  profile_page_update_license: 'Ενημέρωση άδειας',
  profile_page_change_password: 'Αλλαγή κωδικού πρόσβασης',
  profile_page_generate: 'Δημιουργώ',
  profile_page_api_token: 'Token API',
  profile_page_client_id: 'Client ID',
  profile_page_client_secret: 'Client Secret',
  profile_page_show_client_id: 'Εμφάνιση client ID',
  profile_page_hide_client_id: 'Απόκρυψη client ID',
  profile_page_show_client_secret: 'Εμφάνιση client secret',
  profile_page_hide_client_secret: 'Απόκρυψη client secret',
  profile_page_api_token_label: 'Token API',
  profile_page_api_token_valid_for: 'Ισχύει για {{duration}}.',
  profile_page_copy: 'Αντιγραφή',
  profile_page_copied_to_clipboard: 'Αντιγράφηκε στο πρόχειρο.',
  profile_page_failed_to_copy: 'Αποτυχία αντιγραφής στο πρόχειρο.',
  profile_page_token_generated_success: 'Το token δημιουργήθηκε με επιτυχία.',
  profile_page_token_generate_error: 'Αποτυχία δημιουργίας token.',
  profile_page_header: 'Προφίλ',
  profile_page_user_info_label: 'Πληροφορίες χρήστη',
  profile_page_license_label: 'Άδεια ',
  profile_page_license_type: 'Τύπος Άδειας',
  profile_page_valid_from: 'Ισχύει από',
  profile_page_valid_to: 'Ισχύει έως',
  profile_page_max_readings: 'Lecturas máximas',
  profile_page_current_count: 'Τρέχον πλήθος',
  profile_page_first_reading: 'Πρώτη Ανάγνωση',
  profile_page_last_reading: 'Τελευταία Ανάγνωση',
  profile_page_license_status: 'Κατάσταση',
  profile_page_renew_license_button: 'Ανανέωση Άδειας',
  profile_page_deactivate_license_button: 'Απενεργοποίηση Άδειας',
  profile_page_valid_license: 'Έγκυρη Άδεια',
  profile_page_invalid_license: 'Άκυρη Άδεια',
  profile_page_deactivate_license_success_message: 'Η άδεια απενεργοποιήθηκε.',
  profile_page_deactivate_license_error_message: 'Δεν ήταν δυνατή η απενεργοποίηση της άδειας.',
  profile_page_deactivate_modal_title: 'Απενεργοποίηση άδειας',
  profile_page_confirm_button: 'Επιβεβαίωση',
  profile_page_cancel_button: 'Ακύρωση',
  profile_page_deactivate_license_modal_description:
    'Είστε σίγουροι ότι θέλετε να απενεργοποιήσετε αυτή την άδεια;',
  profile_page_activate_license_modal_description:
    'Είστε σίγουροι ότι θέλετε να ενεργοποιήσετε αυτήν την άδεια;',
  profile_page_activate_modal_title: 'Ενεργοποίηση Άδειας',
  profile_page_license_per_device: 'ανά συσκευή',
  profile_page_license_per_reading: 'ανά ανάγνωση',
  profile_page_license_per_sensor: 'ανά αισθητήρα',
  profile_page_license_per_poc: 'ανά δοκιμή έννοιας (POC)',
  profile_page_license_per_remote_node: 'ανά απομακρυσμένο κόμβο',
  profile_page_license_partial: 'μερικός',
  profile_page_logo_file_format_error: 'Μη έγκυρος τύπος αρχείου. Παρακαλώ ανεβάστε μια εικόνα.',
  profile_page_logo_size_error:
    'Το μέγεθος του αρχείου υπερβαίνει το 1MB. Παρακαλώ ανεβάστε μικρότερη εικόνα.',
  profile_page_version_info: 'Τρέχουσες εκδόσεις:',

  logo_error_message: 'Δεν ήταν δυνατή η φόρτωση του λογότυπου της εταιρείας',

  profile_page_country: 'Χώρα',
  profile_page_timezone: 'Ζώνη ώρας',
  profile_page_address: 'Διεύθυνση',
  profile_page_city: 'Πόλη',
  profile_page_municipality: 'Δήμος',
  profile_page_area: 'Περιοχή',
  profile_page_zip_code: 'Ταχυδρομικός κώδικας',
  profile_page_vat_number: 'Αριθμός ΦΠΑ',
  profile_page_edit: 'Επεξεργασία λογαριασμού',
  profile_page_update_account_success: 'Ο λογαριασμός ενημερώθηκε επιτυχώς',
  profile_page_license_info: 'Πληροφορίες άδειας',

  /* |===============|
   * | Utility Rates |
   * |===============|
   */

  util_rates: 'Χρεώσεις βοηθητικών προγραμμάτων',

  // table
  util_rates_name: 'Ονομα',
  util_rates_price: 'Τιμή',
  util_rates_currency: 'Νόμισμα',
  util_rates_unit: 'Μονάδα',
  util_rates_private: 'Ιδιωτικός',
  util_rate_company: 'Εταιρία',
  util_rate_created: 'Δημιουργήθηκε',
  util_rates_updated: 'Επικαιροποιημενο',
  util_rates_actions: 'Ενέργειες',
  util_rates_tooltip_inspect: 'Ελέγχω',

  // modals
  util_rates_add_modal_header: 'Προσθήκη ποσοστού χρησιμότητας',
  util_rates_edit_modal_header: 'Επεξεργασία {{name}}',
  util_rates_delete_modal_header: 'Διαγράφω {{name}}',
  util_rates_delete_modal_body: 'Αυτό θα διαγράψει οριστικά την επιλεγμένη τιμή χρησιμότητας',
  util_rates_confirm: 'Επιβεβαιώνω',
  util_rates_cancel: 'Ματαίωση',
  util_rates_loading: 'Φόρτωση...',
  util_rates_error: 'Λάθος...',
  util_rates_error_name_exists: 'Το όνομα υπάρχει ήδη',

  // errors
  util_rate_fetch_company_error: 'Δεν ήταν δυνατή η φόρτωση εταιρειών',
  util_rate_fetch_util_rates_error:
    'Δεν ήταν δυνατή η φόρτωση των χρεώσεων βοηθητικών προγραμμάτων',

  // footer
  footer_powered_by: 'Υποστηρίζεται από',
  util_rates_name_required: 'Το όνομα είναι υποχρεωτικό',
  util_rates_price_required: 'Η τιμή είναι υποχρεωτική',

  /*
   * |=======|
   * | Icons |
   * |=======|
   */
  icon_type: 'Τύπος',
  icon_type_device: 'Συσκευή',
  icon_type_sensor: 'Αισθητήρας',

  icon_scope: 'Πεδίο εφαρμογής',
  icon_scope_global: 'Παγκόσμια',
  icon_scope_company: 'Εταιρία',
  icon_scope_device: 'Συσκευή',
  icon_scope_sensor: 'Αισθητήρας',

  icon_input_device: 'Συσκευή',
  icon_input_sensor: 'Αισθητήρας',
  icon_input_name: 'Ονομα',
  icon_input_company: 'Εταιρία',

  icon_btn_add_icon: 'Προσθέστε εικονίδιο',
  icon_btn_upload_file: 'Ανέβασμα αρχείου',
  icon_btn_cancel: 'Ματαίωση',
  icon_btn_save: 'Αποθηκεύσετε',

  icon_table_name: 'Ονομα',
  icon_table_scope: 'Πεδίο εφαρμογής',
  icon_table_icon: 'Εικόνισμα',
  icon_table_actions: 'Ενέργειες',

  // errors
  icon_error_update_icon: 'Δεν μπορούσα να ενημερώσω το εικονίδιο',
  icon_error_unsupported_file_type:
    'Μη έγκυρος τύπος αρχείου. Μόνο JPEG, PNG και SVG επιτρέπονται.',
  icon_error_error_occured: 'Παρουσιάστηκε σφάλμα',
  icon_error_enter_name: 'Εισαγάγετε ένα όνομα',
  icon_error_enter_icon: 'Ανεβάστε ένα εικονίδιο',
  icon_error_select_company: 'Επιλέξτε μια εταιρεία',
  icon_error_select_device: 'Επιλέξτε μια συσκευή',
  icon_error_select_sensor: 'Επιλέξτε έναν αισθητήρα',

  /*
   * |=========================|
   * | Customer Billing Report |
   * |=========================|
   */
  customer_billing_report_account_id_table_header: 'Αναγνωριστικό Λογαριασμού',
  customer_billing_report_description_table_header: 'Περιγραφή',
  customer_billing_report_customer_name_table_header: 'Όνομα Πελάτη',
  customer_billing_report_street_table_header: 'Οδός',
  customer_billing_report_quarter_table_header: 'Τετράμηνο',
  customer_billing_report_last_reading_table_header: 'Τελευταία Ανάγνωση',
  customer_billing_report_last_reading_date_table_header: 'Ημερομηνία Τελευταίας Ανάγνωσης',
  customer_billing_report_device_number_table_header: 'Αριθμός Συσκευής',
  customer_billing_report_last_config_date_table_header: 'Ημερομηνία Τελευταίας Διαμόρφωσης',
  customer_billing_report_billing_group_table_header: 'Ομάδα Χρέωσης',
  customer_billing_report_meter_serial_table_header: 'Σειριακό',
  customer_billing_report_diameter_table_header: 'Διάμετρος',
  customer_billing_report_meter_brand_table_header: 'Μάρκα',
  customer_billing_report_meter_model_table_header: 'Μοντέλο',
  customer_billing_report_default_error: 'Προέκυψε σφάλμα κατά τη δημιουργία της αναφοράς',
  customer_billing_report_contract_number_table_header: 'Αριθμός συμβολαίου',
  customer_billing_report_device_name_table_header: 'Όνομα συσκευής',
  customer_billing_report_sensor_name_table_header: 'Όνομα αισθητήρα',

  //license
  license_license_warning: 'Προειδοποίηση Άδειας',
  license_license_warning_per_reading_over_limit_singular:
    'του τύπου ανά ανάγνωση υπερβαίνει το όριο',
  license_license_warning_expire_singular: 'λήγει σύντομα',
  license_license_warning_per_reading_over_limit_plural:
    'του τύπου ανά αναγνώσεις υπερβαίνουν το όριο',
  license_license_warning_expire_plural: 'λήγουν σύντομα',
  license_max_count_error: 'Ο μέγιστος αριθμός δεν μπορεί να είναι 0',

  license_header: 'Άδεια',
  license_table_company_name: 'Όνομα εταιρείας',
  license_table_license_type: 'Τύπος άδειας',
  license_table_max_count: 'Μέγιστος Αριθμός',
  license_table_valid_from: 'Ισχύει από',
  license_table_valid_to: 'Ισχύει έως',
  license_table_first_reading_date: 'Ημερομηνία πρώτης ανάγνωσης',
  license_table_last_reading_date: 'Ημερομηνία τελευταίας ανάγνωσης',
  license_table_active: 'Ενεργό',
  license_table_valid: 'Έγκυρο',
  license_table_prepaid: 'Προπληρωμένη',
  license_table_yes: 'Ναι',
  license_table_no: 'Όχι',
  license_table_actions: 'Ενέργειες',

  license_warning_access_hold: 'Η πρόσβαση στο λογαριασμό είναι σε αναμονή',
  license_warning_access_hold_description:
    'Η πρόσβασή σας στην πλατφόρμα έχει προσωρινά ανασταλεί λόγω ανεπίλυτης πληρωμής. Σας παροτρύνουμε να επικοινωνήσετε με την υποστήριξή μας ή να συνδεθείτε με τον ορισμένο εκπρόσωπό σας για να σας βοηθήσει στην επίλυση αυτού του ζητήματος.',
  license_warning_no_valid_license: 'No hay licencia válida',
  license_warning_no_valid_license_description:
    'No pudimos encontrar una licencia válida asociada con esta cuenta. Comuníquese con su representante designado o contacte nuestro soporte para obtener ayuda.',
  license_warning_devices_count_limit_reached: 'Επιτεύχθηκε το Όριο Συνδεδεμένων Συσκευών',
  license_warning_devices_count_limit_reached_description:
    'Έχετε φτάσει το μέγιστο αριθμό συσκευών που μπορείτε να συνδέσετε στον λογαριασμό σας από την άδεια. Εάν θέλετε να προσθέσετε περισσότερες, επικοινωνήστε με τον εκδοτικό σας αντιπρόσωπο ή την υποστήριξή μας για βοήθεια.',
  license_warning_generic_title: 'Χωρίς άδεια',
  license_warning_generic_description: 'Δεν είναι δυνατή η συνέχιση λόγω προβλήματος με την άδεια.',
  license_info_renew_button: 'Ανανέωση άδειας',
  license_info_deactivate_button: 'Απενεργοποίηση άδειας',
  license_info_renew_modal_button: 'Ανανέωση',
  license_info_used_readings: 'Χρησιμοποιημένες αναφορές',
  license_info_readings_left: 'Αναφορές που απομένουν',
  license_renew_license_button: 'Ανανεώστε',
  license_select_company_warning_message: 'Επιλέξτε μια εταιρεία για να συνεχίσετε',
  license_add_button: 'Προσθήκη Άδειας',
  license_max_devices: 'Μέγιστες συσκευές',
  license_max_readings: 'Μέγιστες αναφορές',
  license_max_sensors: 'Μέγιστοι αισθητήρες',
  license_company: 'Εταιρεία',
  license_deactivate_warning: 'Αυτό θα αναστείλει την πρόσβαση των χρηστών στην πλατφόρμα',
  license_activate_warning: 'Αυτό θα επαναφέρει την πρόσβαση των χρηστών στην πλατφόρμα',
  license_activate_license_button: 'Ενεργοποίηση',
  license_deactivate_license_button: 'Απενεργοποίηση',
  license_available_licenses: 'Διαθέσιμες άδειες',
  license_add_license: 'Προσθήκη άδειας',
  license_status_active: 'Ενεργό',
  license_status_inactive: 'Ανενεργό',
  license_info_activate_button: 'Ενεργοποίηση άδειας',
  license_info_used_devices: 'Χρησιμοποιημένες συσκευές',
  license_info_devices_left: 'Συσκευές που απομένουν',
  license_error_page_access_restricted: 'Περιορισμένη πρόσβαση',
  license_valid_license_existing: 'Έχετε ήδη έναν έγκυρο τύπο αδείας!',
  license_conflicting_license_date: 'Υπάρχει έγκυρη άδεια κατά την ίδια περίοδο',

  license_date_range: 'Εύρος ημερομηνιών',
  license_validity_period: 'Περίοδος ισχύος',
  provide_period: 'Παρακαλώ εισάγετε περίοδο',
  license_table_current_count: 'Τρέχων αριθμός',

  //Password
  change_password: 'Αλλαγή κωδικού πρόσβασης',
  current_password: 'Τρέχων κωδικός πρόσβασης',
  new_password: 'Νέος κωδικός πρόσβασης',
  confirm_new_password: 'Επιβεβαιώστε τον νέο κωδικό πρόσβασης',
  customer_info_saved: 'Οι πληροφορίες του πελάτη αποθηκεύτηκαν',

  password_min_length: 'Ο κωδικός πρόσβασης πρέπει να έχει μήκος τουλάχιστον 10 χαρακτήρες',
  password_uppercase: 'Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον ένα κεφαλαίο γράμμα',
  password_lowercase: 'Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον ένα πεζό γράμμα',
  password_number: 'Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον έναν αριθμό',
  password_special_char: 'Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον έναν ειδικό χαρακτήρα',
  password_mismatch: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',

  /*
   * |=========================|
   * |     Reset Password      |
   * |=========================|
   */
  reset_password_check_email_for_reset_link:
    'Ελέγξτε το email σας για τον σύνδεσμο επαναφοράς κωδικού πρόσβασης',
  reset_password_default_error_message:
    'Παρουσιάστηκε σφάλμα κατά την προσπάθεια επαναφοράς του κωδικού πρόσβασής σας',
  reset_password_change_password_label: 'Αλλαγή κωδικού πρόσβασης',
  reset_password_send_btn: 'Αποστολή',

  /*
   * |==============================|
   * |  Sensors and Network Config  |
   * |==============================|
   */

  //headers
  sensors_and_network_config_network_config: 'Διαμόρφωση Δικτύου Συσκευής',
  sensors_and_network_config_device_details: 'Λεπτομέρειες συσκευής',
  sensors_and_network_config_add_sensor: 'Προσθήκη αισθητήρα',

  //messages
  sensors_and_network_save_success: 'Η ρύθμιση αποθηκεύτηκε με επιτυχία.',
  sensors_and_network_save_error: 'Παρουσιάστηκε πρόβλημα κατά την αποθήκευση της ρύθμισης.',
  sensors_and_network_formula_validation_default_error:
    'Προέκυψε σφάλμα κατά την επικύρωση του τύπου.',
  sensors_and_network_config_required_field_error: 'Αυτό το πεδίο είναι υποχρεωτικό',

  //labels
  sensors_and_network_config_sensor_index: 'Δείκτης αισθητήρα',
  wildPoint_threshold: 'Όριο απότομης μεταβολής',
  scale: 'Κλίμακα',
  precision: 'Ακρίβεια',
  initial_value: 'Αρχική τιμή',

  //buttons
  sensors_and_network_config_reset_btn: 'Επαναφορά',

  //tooltips
  config_tooltip_select_sensor_icon: 'Επιλέξτε εικονίδιο αισθητήρα',
  config_tooltip_sensor_name: 'Όνομα αισθητήρα',
  config_tooltip_enable_disable_sensor: 'Ενεργοποίηση/Απενεργοποίηση αισθητήρα',
  config_tooltip_reset_sensor: 'Επαναφορά νέων αλλαγών για αυτόν τον αισθητήρα',
  config_tooltip_reset_all_fields: 'Επαναφορά όλων των πεδίων στις τελευταίες αποθηκευμένες τιμές',
  config_tooltip_delete_sensor: 'Διαγραφή αισθητήρα',
  config_tooltip_sensor_description: 'Περιγραφή αισθητήρα',
  config_tooltip_sensor_model: 'Μοντέλο αισθητήρα',
  config_tooltip_sensor_serial_number: 'Σειριακός αριθμός αισθητήρα',
  config_tooltip_sensor_manufacturer: 'Κατασκευαστής του αισθητήρα',
  config_tooltip_sensor_useInSensorsAggregation:
    'Υποδεικνύει εάν τα δεδομένα πρέπει να χρησιμοποιηθούν από τον αυτόματο συναθροιστή δεδομένων του Thingslog.',
  config_tooltip_sensor_visibility:
    'Καθορίζει εάν ο αισθητήρας θα πρέπει να είναι ορατός στο portal λύσεων του Thingslog.',
  config_tooltip_sensor_scale:
    'Η ακρίβεια μετά το δεκαδικό ψηφίο για όλους τους υπολογισμούς τύπου.',
  config_tooltip_port_formula: 'Χρησιμοποιείται για τη μετατροπή ακατέργαστων τιμών ADC σε mA ή V',
  config_tooltip_sensor_formula:
    'Χρησιμοποιείται για τη μετατροπή του X σε mA ή V στην μετρημένη τιμή, όπως για παράδειγμα στάθμη, πίεση, θερμοκρασία κ.λπ.',
  config_tooltip_sensor_pulseRate: 'Πόσο ισοδυναμεί μία μονάδα σε έναν παλμό',
  config_tooltip_sensor_offset:
    'Ένας αριθμός (+ ή -) που θα προστεθεί στις μετρήσεις που αποστέλλει η συσκευή.',
  config_tooltip_sensor_flow_units: 'Μονάδες ρυθμού ροής - π.χ. m3/h ή kW/h',
  config_tooltip_sensor_flow_time_units:
    'Η χρονική περίοδος που χρησιμοποιείται για τον υπολογισμό της μονάδας - π.χ. δευτερόλεπτα',
  config_tooltip_sensor_flow_conversion_coefficient:
    'Πόσες χρονικές μονάδες απαιτούνται για να επιτευχθεί η μονάδα από τις ακατέργαστες μετρήσεις',

  config_tooltip_sensor_diameter: 'Διάμετρος σωλήνα',
  config_tooltip_sensor_q3: 'Συντελεστής Q3 του υδρομετρητή',
  config_tooltip_sensor_r: 'Ακρίβεια του υδρομετρητή',
  config_tooltip_wildPoint_threshold:
    'Ορίζει τη μέγιστη επιτρεπτή μεταβολή μεταξύ διαδοχικών μετρήσεων του αισθητήρα. Αν ξεπεραστεί, το πακέτο θεωρείται ελαττωματικό και απορρίπτεται.',
  /*
   * |==============================|
   * |     Documentation Page       |
   * |==============================|
   */

  documentation_title: 'Τεκμηρίωση',
  documentation_platform: 'Τεκμηρίωση πλατφόρμας',
  documentation_data_logger: 'Τεκμηρίωση καταγραφέα δεδομένων',
  documentation_communication_protocol: 'Τεκμηρίωση πρωτοκόλλου επικοινωνίας',
  documentation_sign_in_main_menu: 'Εγγραφή/Σύνδεση και Κύριο μενού',
  documentation_account_management: 'Διαχείριση λογαριασμών ThingsLog',
  documentation_user_management: 'Διαχείριση χρηστών ThingsLog',
  documentation_data_loggers_configuration: 'Διαμόρφωση καταγραφέων δεδομένων ThingsLog',
  documentation_alarms_value_range_events:
    'Ρύθμιση και επισκόπηση συναγερμών και γεγονότων εύρους τιμών ThingsLog',
  documentation_modbus_slave_devices:
    'Διαμόρφωση παραμέτρων θύρας και αισθητήρων για συσκευές Modbus slave',
  documentation_tasmota_devices: 'Ρύθμιση συσκευών Tasmota για εργασία με την πλατφόρμα ThingsLog',
  documentation_modbus_setup: 'Ρύθμιση συσκευών Modbus slave για λειτουργία με ελεγκτές ThingsLog',
  documentation_licenses: 'Άδειες',
  documentation_old_user_manual: 'Παλαιό εγχειρίδιο χρήστη',
  documentation_data_logger_manual: 'Εγχειρίδιο χρήστη καταγραφέα δεδομένων ThingsLog',
  documentation_data_logger_command_guide: 'Οδηγός εντολών καταγραφέα δεδομένων ThingsLog',
  documentation_lora_protocol: 'Ανοικτό πρωτόκολλο δεδομένων LoRa',
  documentation_mqtt_protocol: 'Ανοικτό πρωτόκολλο δεδομένων MQTT',
  documentation_getting_started_training_guide: 'Οδηγός Εκπαίδευσης Ξεκινώντας',
  documentation_view_pdf: 'Προβολή PDF',

  /*
   * |=====================|
   * | Device Nodes Page  |
   * |=====================|
   */

  device_nodes_table_no_links_found: 'Δεν βρέθηκαν συνδέσεις κόμβων συσκευών',
  device_nodes_table_error: 'Αποτυχία ανάκτησης συνδέσεων κόμβων συσκευών',
  device_nodes_table_source_device_number: 'Αριθμός Συσκευής Προέλευσης',
  device_nodes_table_source_sensor_index: 'Δείκτης Αισθητήρα Προέλευσης',
  device_nodes_table_target_device_number: 'Αριθμός Συσκευής Προορισμού',
  device_nodes_table_target_sensor_index: 'Δείκτης Αισθητήρα Προορισμού',
  device_nodes_table_is_active: 'Είναι Ενεργό',

  device_nodes_create_link: 'Δημιουργία Σύνδεσης',
  device_nodes_source_device_required: 'Η συσκευή προέλευσης είναι υποχρεωτική',
  device_nodes_source_device: 'Συσκευή Προέλευσης',
  device_nodes_sensor_index_required: 'Ο δείκτης αισθητήρα είναι υποχρεωτικός',
  device_nodes_sensor_index_min: 'Ο δείκτης αισθητήρα πρέπει να είναι τουλάχιστον 0',
  device_nodes_source_sensor_index: 'Δείκτης Αισθητήρα Προέλευσης',
  device_nodes_target_device_required: 'Η συσκευή προορισμού είναι υποχρεωτική',
  device_nodes_target_device: 'Συσκευή Προορισμού',
  device_nodes_target_sensor_index: 'Δείκτης Αισθητήρα Προορισμού',
  device_nodes_is_active: 'Είναι Ενεργό',
  device_nodes_create_link_button: 'Δημιουργία Σύνδεσης',
  device_nodes_same_device_error:
    'Η συσκευή προέλευσης και η συσκευή προορισμού δεν μπορούν να είναι ίδιες',

  device_nodes_delete_links: 'Διαγραφή συνδέσμων',
  device_nodes_device_required: 'Η συσκευή είναι υποχρεωτική',
  device_nodes_device: 'Συσκευή',
  device_nodes_role_required: 'Ο ρόλος είναι υποχρεωτικός',
  device_nodes_role: 'Ρόλος',
  device_nodes_role_source: 'Πηγή',
  device_nodes_role_target: 'Στόχος',
  device_nodes_sensor_index: 'Αισθητήρας (Προαιρετικό)',
  device_nodes_no_sensors_available: 'Δεν υπάρχουν διαθέσιμοι αισθητήρες',
  device_nodes_sensor_optional: 'Αφήστε κενό για να διαγράψετε όλους τους συνδέσμους συσκευής',
  device_nodes_delete_warning: 'Προειδοποίηση: Αυτή η ενέργεια δεν μπορεί να αναιρεθεί!',
  device_nodes_delete_button: 'Διαγραφή συνδέσμων',

  /*
   * |======================|
   * | Scheduled Reports   |
   * |======================|
   */
  // Generated Reports Page
  generated_reports_header: 'Δημιουργημένες αναφορές',
  generated_reports_select_company_message:
    'Επιλέξτε μια εταιρεία για να δείτε τις δημιουργημένες αναφορές',
  generated_reports_default_error:
    'Παρουσιάστηκε σφάλμα κατά την ανάκτηση των δημιουργημένων αναφορών',
  generated_reports_config_button: 'Διαμόρφωση',
  generated_reports_config_name_header: 'Όνομα διαμόρφωσης αναφοράς',
  generated_reports_date_header: 'Ημερομηνία αναφοράς',
  generated_reports_type_header: 'Τύπος αναφοράς',
  generated_reports_file_name_header: 'Όνομα αρχείου',
  generated_reports_parameters_header: 'Παράμετροι',

  // Report Configs Page
  report_configs_header: 'Διαμορφώσεις αναφορών',
  report_configs_select_company_message:
    'Επιλέξτε μια εταιρεία για να διαχειριστείτε τις διαμορφώσεις αναφορών',
  report_configs_default_error: 'Παρουσιάστηκε σφάλμα κατά την ανάκτηση των διαμορφώσεων αναφορών',
  report_configs_name_header: 'Όνομα αναφοράς',
  report_configs_type_header: 'Τύπος αναφοράς',
  report_configs_occurrence_header: 'Συχνότητα',
  report_configs_device_groups_header: 'Ομάδες συσκευών',
  report_configs_email_list_header: 'Λίστα email',
  report_configs_start_date_header: 'Ημερομηνία έναρξης',
  report_configs_end_date_header: 'Ημερομηνία λήξης',
  report_configs_next_execution_header: 'Επόμενη εκτέλεση',
  report_configs_actions_header: 'Ενέργειες',
  report_configs_delete_action: 'Διαγραφή',
  report_configs_delete_success: 'Η διαμόρφωση αναφοράς διαγράφηκε επιτυχώς',
  report_configs_delete_error: 'Παρουσιάστηκε σφάλμα κατά τη διαγραφή της διαμόρφωσης αναφοράς',
  report_configs_create_button: 'Δημιουργία διαμόρφωσης αναφοράς',
  report_configs_edit_action: 'Επεξεργασία',

  // Report Config Form
  report_config_form_report_name: 'Όνομα αναφοράς',
  report_config_form_report_type: 'Τύπος αναφοράς',
  report_config_form_occurrence: 'Συχνότητα',
  report_config_form_device_groups: 'Ομάδες συσκευών',
  report_config_form_email_list: 'Λίστα email',
  report_config_form_email_list_hint: 'Διαχωρίστε πολλαπλά email με κόμματα',
  report_config_form_start_date: 'Ημερομηνία έναρξης',
  report_config_form_end_date: 'Ημερομηνία λήξης',
  report_config_form_calculate: 'Υπολογισμός',
  report_config_form_calc_min: 'Ελάχιστο',
  report_config_form_calc_max: 'Μέγιστο',
  report_config_form_calc_average: 'Μέσος όρος',
  report_config_form_cancel: 'Ακύρωση',
  report_config_form_create: 'Δημιουργία',
  report_config_form_update: 'Ενημέρωση',
  report_config_form_field_required: 'Αυτό το πεδίο είναι υποχρεωτικό',
  report_config_form_device_groups_required: 'Πρέπει να επιλεγεί τουλάχιστον μία ομάδα συσκευών',
  report_config_form_license_settings: 'Ρυθμίσεις αναφοράς άδειας',
  report_config_form_license_is_active: 'Είναι ενεργό',
  report_config_form_license_is_valid: 'Είναι έγκυρο',

  // Report Types
  report_type_consumption: 'Αναφορά κατανάλωσης',
  report_type_consumption_export: 'Εξαγωγή κατανάλωσης',
  report_type_customer_billing: 'Αναφορά χρέωσης πελάτη',
  report_type_alarm: 'Αναφορά συναγερμών',
  report_type_transmission: 'Αναφορά μετάδοσης',
  report_type_license: 'Αναφορά άδειας',

  // Report Occurrence
  report_occurrence_daily: 'Ημερήσια',
  report_occurrence_weekly: 'Εβδομαδιαία',
  report_occurrence_monthly: 'Μηνιαία',

  // Create/Edit Pages
  report_config_create_header: 'Δημιουργία διαμόρφωσης αναφοράς',
  report_config_create_success: 'Η διαμόρφωση αναφοράς δημιουργήθηκε επιτυχώς',
  report_config_create_error: 'Παρουσιάστηκε σφάλμα κατά τη δημιουργία της διαμόρφωσης αναφοράς',
  report_config_edit_header: 'Επεξεργασία διαμόρφωσης αναφοράς',
  report_config_update_success: 'Η διαμόρφωση αναφοράς ενημερώθηκε επιτυχώς',
  report_config_update_error: 'Παρουσιάστηκε σφάλμα κατά την ενημέρωση της διαμόρφωσης αναφοράς',
  report_config_fetch_error: 'Παρουσιάστηκε σφάλμα κατά την ανάκτηση της διαμόρφωσης αναφοράς',
  report_config_not_found: 'Η διαμόρφωση αναφοράς δεν βρέθηκε',
  report_config_form_email_list_required:
    'Απαιτείται τουλάχιστον μία διεύθυνση ηλεκτρονικού ταχυδρομείου',
  report_config_form_email_invalid: 'Μη έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου: {{email}}',
  report_config_form_email_no_spaces:
    'Οι διευθύνσεις ηλεκτρονικού ταχυδρομείου δεν μπορούν να περιέχουν κενά',
  report_configs_delete_confirm_title: 'Διαγραφή διαμόρφωσης αναφοράς',
  report_configs_delete_confirm_message:
    'Είστε σίγουροι ότι θέλετε να διαγράψετε τη διαμόρφωση αναφοράς "{{reportName}}"; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
  report_configs_delete_cancel: 'Ακύρωση',
  report_configs_delete_confirm: 'Διαγραφή',
  report_configs_deleting: 'Διαγραφή...',

  /*
   * |====================|
   * | Sensors Data Page  |
   * |====================|
   */

  // Page
  sensors_data_no_selection_made: 'Δεν έγινε επιλογή',
  sensors_data_no_selection_subtitle:
    'Χρησιμοποιήστε τα στοιχεία ελέγχου παραπάνω για να επιλέξετε μια συσκευή ή μια ομάδα συσκευών για να δείτε τις μετρήσεις των αισθητήρων τους.',

  // Device Readings Selector Generic
  sensors_data_select_device_group: 'Επιλέξτε ομάδα συσκευών',
  sensors_data_search_device_group: 'Αναζήτηση με όνομα ομάδας συσκευών',
  sensors_data_add: 'Προσθήκη',
  sensors_data_select_device: 'Επιλέξτε συσκευή',
  sensors_data_search_device: 'Αναζήτηση με όνομα ή αριθμό συσκευής',
  sensors_data_select_sensor: 'Επιλέξτε αισθητήρα',
  sensors_data_search_sensor: 'Αναζήτηση με όνομα ή ευρετήριο αισθητήρα',
  sensors_data_select_devices: 'Επιλέξτε συσκευές',
  sensors_data_select_sensor_type: 'Επιλέξτε τύπο αισθητήρα',
  sensors_data_search_sensor_type: 'Αναζήτηση με τύπο αισθητήρα',
  sensors_data_submit: 'Υποβολή',

  // Device Readings Selector Specific
  sensors_data_select_sensors: 'Επιλέξτε αισθητήρες',

  // Selected Items Display
  sensors_data_group: 'Ομάδα',

  // Readings Data Display
  sensors_data_click_to_view_readings: 'Κάντε κλικ για να δείτε τις μετρήσεις',
  sensors_data_view_sensor_data_subtitle: 'Προβολή δεδομένων αισθητήρα και πληροφοριών εξαγωγής',
  sensors_data_raw: 'Ακατέργαστα',
  sensors_data_export: 'Εξαγωγή',
  sensors_data_format: 'Μορφή',
  sensors_data_csv: 'CSV',
  sensors_data_excel: 'EXCEL',
  sensors_data_device_number: 'Αριθμός συσκευής',
  sensors_data_device_name: 'Όνομα συσκευής',
  sensors_data_sensor_name: 'Όνομα αισθητήρα',
  sensors_data_date: 'Ημερομηνία',
  sensors_data_value: 'Τιμή',
  sensors_data_no_data_available: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
  sensors_data_sensor_index: 'Ευρετήριο αισθητήρα',
  sensors_data_counters: 'Μετρητές',
  sensors_data_previous: 'Προηγούμενο',
  sensors_data_delta: 'Δέλτα',
  sensors_data_collapse: 'Σύμπτυξη',

  // Sensors Data Chart
  sensors_data_chart_no_data_available: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
  sensors_data_chart_no_numeric_data_subtitle:
    'Το αίτημα ήταν επιτυχές, αλλά δεν επιστράφηκαν αριθμητικά δεδομένα για την επιλεγμένη περίοδο.',
  sensors_data_chart_min: 'ελάχ -',
  sensors_data_chart_max: 'μέγ -',

  // Sensors Data Map
  sensors_data_map_loading: 'Φόρτωση χάρτη...',

  //Warranty Data
  manufacturing_date: 'Ημερομηνία κατασκευής',

  warranty_type: 'Τύπος εγγύησης',
  warranty_extended_support: 'Εκτεταμένη υποστήριξη',
  warranty_basic: 'Βασική',

  warranty_status: 'Κατάσταση εγγύησης',
  warranty_status_UNKNOWN: 'Άγνωστη',
  warranty_status_IN_WARRANTY: 'Σε εγγύηση',
  warranty_status_EXPIRED: 'Έληξε',
  warranty_period_months: 'Περίοδος εγγύησης',

  install_date: 'Ημερομηνία εγκατάστασης',
  install_warranty_exp_date: 'Ημερομηνία λήξης εγγύησης εγκατάστασης',
  install_warranty_period_months: 'Περίοδος εγγύησης εγκατάστασης',

  // Mobile Query Preview
  sensors_data_mobile_groups: 'Ομάδα(ες)',
  sensors_data_mobile_sensors: 'Αισθητήρας(ες)',
  sensors_data_mobile_types: 'Τύπος(οι)',
  sensors_data_mobile_no_filters_selected: 'Δεν έχουν επιλεγεί φίλτρα',

  // Quick Sensor Selector
  sensors_data_quick_select_sensor: 'Επιλέξτε έναν αισθητήρα για να δείτε τις μετρήσεις',

  // Mobile Fab Button
  sensors_data_view_table: 'προβολή πίνακα',
  sensors_data_view_chart: 'προβολή γραφήματος',
  // Fallbacks added to keep locale keys aligned with English.
  confirm_registration_welcome_to_thingslog: 'Welcome to Thingslog!',
  confirm_registration_completed: 'REGISTRATION COMPLETED',
  confirm_registration_failed: 'REGISTRATION FAILED',
  confirm_registration_completed_description:
    'Your registration process is completed. You can login now. If you face issue, contact our support at {{email}}',
  confirm_registration_failed_description:
    'We encountered a problem with registration. If you face issues logging in, please, contact our support at {{email}}',
  confirm_registration_visit_website: 'Visit Our Website',
  confirm_registration_visit_ecommerce: 'Visit Our Online Store',
  link_device_default_error: 'There was a problem linking/unlinking the device',
  link_device_company_not_found_error: 'Company not found',
  device_counter_statistics_must_have_initialized_params:
    'Parameters Q3, R, and Diameter are required on pulse input connected to a water meter sensor.',
  login_form_forgot_password: 'Forgot password?',
  transmissions_page_yes: 'Yes',
  transmissions_page_no: 'No',
  license_add_success_message: 'License created successfully',
  license_add_error_message: 'An error occured during the process',
  device_groups_add_sensor_device: 'Add sensor and device to group',
  value_range_name_incorrect_time: 'Incorrect time format',
  value_range_error_occurred: 'An error occurred',
  // Dashboard localization additions
  cancel: 'Ακύρωση',
  edit: 'Επεξεργασία',
  save_btn: 'Αποθήκευση',
  resize: 'Αλλαγή μεγέθους',
  value: 'Τιμή',
  time: 'Ώρα',
  dashboards_title: 'Πίνακες',
  dashboard_add_dashboard: 'Προσθήκη Πίνακας',
  dashboard_edit_dashboard: 'Επεξεργασία Πίνακας',
  dashboard_delete_dashboard: 'Διαγραφή Πίνακας',
  dashboard_search_dashboards: 'Αναζήτηση πίνακες',
  dashboard_search_by_name: 'αναζήτηση κατά όνομα',
  dashboard_create_dashboard: 'Δημιουργία Πίνακας',
  dashboard_save_dashboard: 'Αποθήκευση Πίνακας',
  dashboard_name: 'Πίνακας Όνομα',
  dashboard_name_required: 'Πίνακας Όνομα είναι υποχρεωτικό',
  dashboard_name_max_length: 'Πίνακας Όνομα πρέπει να είναι κάτω από 100 χαρακτήρες',
  dashboard_time_period: 'Χρονική περίοδος',
  dashboard_dashboard_time_period: 'Χρονική περίοδος πίνακα',
  dashboard_dashboard_time_period_description:
    'Η προεπιλεγμένη χρονική περίοδος δεδομένων για τον πίνακα.',
  dashboard_save_period: 'Αποθήκευση Περίοδος',
  dashboard_edit_dashboard_period: 'Επεξεργασία Περίοδος πίνακα',
  dashboard_period: 'Περίοδος πίνακα',
  dashboard_predefined_period: 'Προκαθορισμένη περίοδος',
  dashboard_period_dashboard: 'Πίνακας',
  dashboard_period_predefined: 'Προκαθορισμένο',
  dashboard_period_preset: 'Προεπιλογή',
  dashboard_period_custom: 'Προσαρμοσμένο',
  dashboard_timespan_today: 'Σήμερα',
  dashboard_timespan_yesterday: 'Χθες',
  dashboard_timespan_this_week: 'Αυτή την εβδομάδα',
  dashboard_timespan_this_month: 'Αυτόν τον μήνα',
  dashboard_timespan_this_year: 'Φέτος',
  dashboard_timespan_past_1d: 'Τελευταία 1 ημέρα',
  dashboard_timespan_past_1w: 'Τελευταία 1 εβδομάδα',
  dashboard_timespan_past_1m: 'Τελευταίος 1 μήνας',
  dashboard_timespan_past_1y: 'Τελευταίο 1 έτος',
  dashboard_start_date_required: 'Έναρξη date is required',
  dashboard_end_date_required: 'Η ημερομηνία λήξης είναι υποχρεωτική',
  dashboard_end_date_before_start_error: 'λήξη ημερομηνία πριν έναρξη σφάλμα',
  dashboard_predefined_period_required: 'προκαθορισμένο περίοδος υποχρεωτικό',
  dashboard_default_dashboard_name: 'Προεπιλογή Πίνακας',
  dashboard_loading: 'Φόρτωση...',
  dashboard_redirecting: 'Ανακατεύθυνση...',
  dashboards_load_error: 'φόρτωση σφάλμα',
  dashboard_load_error: 'φόρτωση σφάλμα',
  dashboard_loading_data_sources: 'φόρτωση δεδομένα πηγές',
  dashboard_data_sources_load_error: 'δεδομένα πηγές φόρτωση σφάλμα',
  dashboard_empty_title: 'Δημιουργήστε το πρώτο σας widget',
  dashboard_empty_description:
    'Προσθέστε ένα widget για να αρχίσετε να εμφανίζετε δεδομένα σε αυτόν τον πίνακα.',
  dashboard_confirm_changes_title: 'Επιβεβαίωση αλλαγών',
  dashboard_save_layout_confirmation:
    'Είστε βέβαιοι ότι θέλετε να αποθηκεύσετε τις αλλαγές σας; Όλες οι αλλαγές θα εφαρμοστούν στον πίνακα.',
  dashboard_save_layout: 'Αποθήκευση διάταξη',
  dashboard_edit_layout: 'Επεξεργασία διάταξη',
  dashboard_add_widget: 'Προσθήκη widget',
  dashboard_widgets: 'Widgets',
  dashboard_widget: 'Widget',
  dashboard_untitled_widget: 'Widget χωρίς τίτλο',
  dashboard_no_widgets_yet: 'όχι widgets yet',
  dashboard_create_widget: 'Δημιουργία widget',
  dashboard_save_widget: 'Αποθήκευση widget',
  dashboard_edit_widget: 'Επεξεργασία widget',
  dashboard_delete_widget: 'Διαγραφή widget',
  dashboard_yes_delete: 'Ναι, διαγραφή',
  dashboard_widget_no_longer_exists: 'Το widget δεν υπάρχει πλέον.',
  dashboard_widget_delete_confirmation_prefix: 'Αυτό θα διαγράψει οριστικά το widget',
  dashboard_widget_delete_confirmation_suffix: 'Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
  dashboards_empty_no_dashboards_title: 'Δεν υπάρχουν πίνακες',
  dashboards_empty_no_results_title: 'Δεν υπάρχουν αποτελέσματα',
  dashboards_empty_no_dashboards_description: 'Δεν έχουν δημιουργηθεί ακόμη πίνακες.',
  dashboards_empty_no_results_description:
    'Δεν υπάρχουν πίνακες που να ταιριάζουν με την αναζήτηση.',
  dashboard_add_default_dashboard: 'Προσθήκη Προεπιλογή Πίνακας',
  dashboard_this_dashboard: 'αυτό πίνακας',
  dashboard_delete_confirmation: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το {{name}};',
  dashboard_no_longer_exists: 'Πίνακας Το  δεν υπάρχει πλέον.',
  dashboard_edit_named_dashboard: 'Επεξεργασία {{name}}',
  dashboard_fallback_dashboard: 'Πίνακας',
  dashboard_edit_current_dashboard: 'επεξεργασία τρέχον πίνακας',
  dashboard_all_dashboards: 'All Πίνακες',
  dashboard_start_selector_guide: 'έναρξη επιλογέας οδηγός',
  dashboard_close_dashboards: 'Κλείσιμο πίνακες',
  dashboard_open_dashboards: 'Άνοιγμα πίνακες',
  dashboard_edit_period: 'Επεξεργασία πίνακας περίοδος',
  dashboard_variables: 'Μεταβλητές',
  dashboard_hide_app_header: 'Απόκρυψη κεφαλίδας εφαρμογής',
  dashboard_show_app_header: 'Εμφάνιση κεφαλίδας εφαρμογής',
  dashboard_start_tour: 'έναρξη ξενάγηση',
  dashboard_remove_from_favorites: 'Αφαίρεση από αγαπημένα',
  dashboard_add_to_favorites: 'Προσθήκη στα αγαπημένα',
  dashboard_default_dashboard: 'Προεπιλογή πίνακας',
  dashboard_set_as_default: 'Ορισμός ως προεπιλογή',
  dashboard_favorite_tooltip: 'Σήμανση ως αγαπημένο',
  dashboard_default_tooltip: 'Προεπιλεγμένος πίνακας',
  dashboard_widget_type: 'Τύπος widget',
  dashboard_widget_type_required: 'Ο τύπος widget είναι υποχρεωτικός',
  dashboard_widget_type_line_chart: 'Γραμμικό γράφημα',
  dashboard_widget_type_bar_chart: 'Ραβδόγραμμα',
  dashboard_widget_type_pie_chart: 'Γράφημα πίτας',
  dashboard_widget_type_area_chart: 'Γράφημα περιοχής',
  dashboard_widget_type_gauge: 'Μετρητής',
  dashboard_widget_type_value: 'Τιμή',
  dashboard_widget_type_table: 'Πίνακας',
  dashboard_widget_title: 'Τίτλος',
  dashboard_widget_title_required: 'Ο τίτλος είναι υποχρεωτικός',
  dashboard_widget_title_max_length: 'Ο τίτλος πρέπει να είναι κάτω από 100 χαρακτήρες',
  dashboard_data_source: 'Πηγή δεδομένων',
  dashboard_data_source_required: 'Η πηγή δεδομένων είναι υποχρεωτική',
  dashboard_query_settings: 'Ρυθμίσεις ερωτήματος',
  dashboard_no_data_sources_available: 'Δεν υπάρχουν διαθέσιμες πηγές δεδομένων',
  dashboard_no_data_sources_description:
    'Ρυθμίστε μια πηγή δεδομένων πίνακα πριν δημιουργήσετε ή επεξεργαστείτε widgets.',
  dashboard_select_data_source_to_configure_query:
    'Επιλέξτε πηγή δεδομένων για να ρυθμίσετε το ερώτημα.',
  dashboard_query_type_not_supported: 'Αυτός ο τύπος ερωτήματος δεν υποστηρίζεται ακόμη.',
  dashboard_no_widget_timeframe: 'Δεν υπάρχει χρονικό διάστημα widget',
  dashboard_no_widget_timeframe_description:
    'Αυτό το widget κληρονομεί τη χρονική περίοδο από τον πίνακα.',
  dashboard_widget_time_period: 'Χρονική περίοδος widget',
  dashboard_widget_time_period_description:
    'Ορίστε ξεχωριστή περίοδο για αυτό το widget ή χρησιμοποιήστε την περίοδο του πίνακα.',
  dashboard_edit_widget_timeframe: 'Επεξεργασία χρονικής περιόδου widget',
  dashboard_edit_widget_timeframe_inherited:
    'Επεξεργασία χρονικής περιόδου widget. Αυτή τη στιγμή κληρονομείται από τον πίνακα.',
  dashboard_widget_settings: 'Ρυθμίσεις widget',
  dashboard_shift_scroll_to_zoom: 'Shift + κύλιση για μεγέθυνση',
  dashboard_zoom_in: 'Μεγέθυνση',
  dashboard_zoom_out: 'Σμίκρυνση',
  dashboard_zoom_reset: 'Επαναφορά ζουμ',
  dashboard_inherited_timeframe_label: 'Πίνακας: {{label}}',
  dashboard_edit_timeframe: 'Επεξεργασία χρονικής περιόδου',
  dashboard_edit_widget_period: 'Επεξεργασία περιόδου widget',
  dashboard_edit_named_widget: 'Επεξεργασία {{name}}',
  dashboard_edit_named_widget_period: 'Επεξεργασία {{name}} Περίοδος',
  dashboard_data_type: 'Τύπος δεδομένων',
  dashboard_data_type_description:
    'Επιλέξτε αν το ερώτημα προτιμά μετρήσεις ή υπολογισμένες τιμές ροής.',
  dashboard_readings: 'Μετρήσεις',
  dashboard_query_time_period_description:
    'Επιλέξτε το χρονικό εύρος για τα δεδομένα του ερωτήματος.',
  dashboard_battery_level: 'Επίπεδο μπαταρίας',
  dashboard_battery_level_description: 'Περιορίζει το widget σε εύρος ποσοστού μπαταρίας.',
  dashboard_signal_level: 'Επίπεδο σήματος',
  dashboard_signal_level_description: 'Περιορίζει το widget σε εύρος ποσοστού σήματος.',
  dashboard_signal_values: 'Τιμές σήματος',
  dashboard_signal_values_description: 'Επιλέξτε ποιες τιμές σήματος θα εμφανίζονται.',
  dashboard_signal_value_required: 'Επιλέξτε τουλάχιστον μία τιμή σήματος',
  dashboard_transmission_values: 'Τιμές μεταδόσεων',
  dashboard_transmission_values_description: 'Επιλέξτε ποιες τιμές μετάδοσης θα εμφανίζονται.',
  dashboard_transmission_value_required: 'Επιλέξτε τουλάχιστον μία τιμή μετάδοσης',
  dashboard_days: 'Ημέρες',
  dashboard_transmissions: 'Μεταδόσεις',
  dashboard_count: 'Πλήθος',
  dashboard_unit_days: 'ημέρες',
  dashboard_transmitting: 'Μεταδίδει',
  devices: 'Συσκευές',
  dashboard_device_sensor: 'Αισθητήρας συσκευής',
  dashboard_device_sensor_description: 'Επιλέξτε συσκευή και αισθητήρα για αυτό το widget.',
  dashboard_device_required: 'Η συσκευή είναι υποχρεωτική',
  dashboard_sensor_required: 'Ο αισθητήρας είναι υποχρεωτικός',
  dashboard_devices_optional_description:
    'Pick συσκευές to include. Leave empty to include all συσκευές.',
  dashboard_no_devices_selected_uses_all:
    'Δεν έχουν επιλεγεί συσκευές. Το widget θα χρησιμοποιήσει όλες τις συσκευές.',
  dashboard_device_groups: 'Ομάδες συσκευών',
  dashboard_device_groups_description:
    'Επιλέξτε μία ή περισσότερες ομάδες συσκευών για το ερώτημα.',
  dashboard_select_one_device_group_required: 'Επιλέξτε τουλάχιστον μία ομάδα συσκευών',
  dashboard_device_groups_optional_description: 'Προαιρετικές πηγές ομάδων για το μικτό ερώτημα.',
  dashboard_no_groups_selected: 'Δεν έχουν επιλεγεί ομάδες.',
  dashboard_device_sensors: 'Αισθητήρες συσκευής',
  dashboard_device_sensors_description: 'Προσθέστε ζεύγη συσκευής και αισθητήρα που θα διαβαστούν.',
  dashboard_device_sensors_optional_description:
    'Προαιρετικά ζεύγη αριθμών συσκευών και δεικτών αισθητήρων.',
  dashboard_add_device_sensor_required: 'Προσθέστε τουλάχιστον έναν αισθητήρα συσκευής',
  dashboard_add_device_sensor: 'Προσθήκη Αισθητήρας συσκευής',
  dashboard_remove_device_sensor: 'Remove συσκευή αισθητήρας',
  dashboard_device_sensor_types: 'Τύποι αισθητήρων συσκευής',
  dashboard_device_sensor_types_description:
    'Επιλέξτε συσκευές και τον τύπο αισθητήρα που θα διαβαστεί από αυτές.',
  dashboard_device_sensor_types_optional_description:
    'Προαιρετικές ομάδες συσκευών αντιστοιχισμένες ανά τύπο αισθητήρα.',
  dashboard_add_device_sensor_type_required: 'Προσθέστε τουλάχιστον έναν τύπο αισθητήρα συσκευής',
  dashboard_sensor_type: 'Αισθητήρας Τύπος',
  dashboard_add_sensor_type: 'Προσθήκη Αισθητήρας Τύπος',
  dashboard_remove_sensor_type: 'Αφαίρεση τύπου αισθητήρα',
  dashboard_variable: 'μεταβλητή',
  dashboard_sensor_index_option: 'Αισθητήρας {{index}}',
  dashboard_visualization: 'Οπτικοποίηση',
  dashboard_visualization_description: 'Επιλογές εμφάνισης και στυλ γραφήματος',
  dashboard_visualization_show_grid: 'Εμφάνιση πλέγματος',
  dashboard_visualization_show_legend: 'Εμφάνιση υπομνήματος',
  dashboard_visualization_render_legend_aside: 'Υπόμνημα στο πλάι',
  dashboard_visualization_show_legend_aside: 'Υπόμνημα στο πλάι',
  dashboard_visualization_show_x_axis_labels: 'Εμφάνιση ετικετών άξονα X',
  dashboard_visualization_show_y_axis_labels: 'Εμφάνιση ετικετών άξονα Y',
  dashboard_visualization_line_thickness: 'Πάχος γραμμής',
  dashboard_visualization_interpolation: 'Παρεμβολή',
  dashboard_visualization_show_points: 'Εμφάνιση σημείων',
  dashboard_visualization_points_hidden_helper:
    'Τα σημεία αποκρύπτονται αυτόματα όταν η χρονοσειρά έχει πάνω από {{count}} σημεία.',
  dashboard_visualization_stack_series: 'Στοίβαξη σειρών',
  dashboard_visualization_fill_opacity: 'Αδιαφάνεια γεμίσματος',
  dashboard_visualization_orientation: 'Προσανατολισμός',
  dashboard_visualization_grouping: 'Ομαδοποίηση',
  dashboard_visualization_bar_thickness: 'Πάχος ράβδου',
  dashboard_visualization_shape: 'Σχήμα',
  dashboard_visualization_gauge_type: 'Τύπος μετρητή',
  dashboard_visualization_bar_orientation: 'Προσανατολισμός ράβδου',
  dashboard_visualization_minimum: 'Ελάχιστο',
  dashboard_visualization_maximum: 'Μέγιστο',
  dashboard_visualization_gauge_color: 'Χρώμα μετρητή',
  dashboard_visualization_value_color: 'Βασικό χρώμα',
  dashboard_visualization_value_prefix: 'Πρόθεμα',
  dashboard_visualization_value_suffix: 'Επίθημα',
  dashboard_visualization_value_stacked: 'Πρόθεμα πάνω, επίθημα κάτω',
  dashboard_visualization_value_compact: 'Συμπαγείς αριθμοί',
  dashboard_visualization_value_target: 'Στόχος',
  dashboard_visualization_value_show_target_percentage: 'Εμφάνιση % του στόχου',
  dashboard_visualization_value_text_color: 'Προσαρμοσμένο χρώμα κειμένου',
  dashboard_visualization_colors: 'Χρώματα',
  dashboard_value_percent_of_target: '{{percent}}% του στόχου',
  dashboard_value_percent_above_target: '{{percent}}% πάνω από τον στόχο',
  dashboard_visualization_show_value: 'Εμφάνιση τιμής',
  dashboard_visualization_show_min_max: 'Εμφάνιση ελάχ./μέγ.',
  dashboard_visualization_show_thresholds: 'Εμφάνιση ορίων',
  dashboard_visualization_paginate_rows: 'Σελιδοποίηση γραμμών',
  dashboard_visualization_thresholds: 'Όρια',
  dashboard_visualization_add_threshold: 'Προσθήκη ορίου',
  dashboard_visualization_level: 'Επίπεδο',
  dashboard_visualization_label: 'Ετικέτα',
  dashboard_visualization_color: 'Χρώμα',
  dashboard_visualization_remove_threshold: 'Αφαίρεση ορίου',
  dashboard_visualization_threshold_warning: 'Προειδοποίηση',
  dashboard_visualization_threshold_critical: 'Κρίσιμο',
  dashboard_visualization_threshold_named: 'Όριο {{index}}',
  dashboard_visualization_option_fine: 'Λεπτό',
  dashboard_visualization_option_standard: 'Τυπικό',
  dashboard_visualization_option_bold: 'Έντονο',
  dashboard_visualization_option_straight: 'Ευθεία',
  dashboard_visualization_option_smooth: 'Ομαλή',
  dashboard_visualization_option_stepped: 'Βηματική',
  dashboard_visualization_option_subtle: 'Διακριτικό',
  dashboard_visualization_option_balanced: 'Ισορροπημένο',
  dashboard_visualization_option_solid: 'Συμπαγές',
  dashboard_visualization_option_vertical: 'Κάθετο',
  dashboard_visualization_option_horizontal: 'Οριζόντιο',
  dashboard_visualization_option_grouped: 'Ομαδοποιημένο',
  dashboard_visualization_option_stacked: 'Στοιβαγμένο',
  dashboard_visualization_option_slim: 'Λεπτό',
  dashboard_visualization_option_regular: 'Κανονικό',
  dashboard_visualization_option_wide: 'Πλατύ',
  dashboard_visualization_option_pie: 'Πίτα',
  dashboard_visualization_option_donut: 'Δακτύλιος',
  dashboard_visualization_option_dial: 'Καντράν',
  dashboard_visualization_option_bar: 'Ράβδος',
  dashboard_add_variable: 'Προσθήκη Μεταβλητή',
  dashboard_edit_variable: 'Επεξεργασία Μεταβλητή',
  dashboard_delete_variable: 'Διαγραφή Μεταβλητή',
  dashboard_variable_no_longer_exists: 'Η μεταβλητή δεν υπάρχει πλέον.',
  dashboard_edit_named_variable: 'Επεξεργασία {{name}}',
  dashboard_variable_edit_mode_description:
    'Οι τοπικές αλλαγές επηρεάζουν μόνο αυτήν την προβολή πίνακα. Οι απομακρυσμένες αλλαγές ενημερώνουν την αποθηκευμένη μεταβλητή.',
  dashboard_local: 'Τοπικό',
  dashboard_remote: 'Απομακρυσμένο',
  dashboard_variable_name: 'Όνομα',
  dashboard_variable_name_required: 'Όνομα is required',
  dashboard_variable_name_pattern: 'μεταβλητή όνομα pattern',
  dashboard_variable_label: 'Ετικέτα',
  dashboard_variable_label_required: 'Ετικέτα is required',
  dashboard_variable_single: 'Μονή',
  dashboard_variable_multi: 'Πολλαπλή',
  dashboard_variable_value: 'Τιμή',
  dashboard_variable_values: 'Τιμές',
  dashboard_variable_value_required: 'Τιμή is required',
  dashboard_variable_at_least_one_value_required: 'Απαιτείται τουλάχιστον μία τιμή',
  dashboard_variable_values_helper: 'Χωρίστε πολλαπλές τιμές με κόμματα.',
  dashboard_apply_locally: 'Εφαρμογή locally',
  dashboard_no_variables_yet: 'Δεν υπάρχουν μεταβλητές',
  dashboard_no_variables_description: 'Δεν υπάρχουν ακόμη μεταβλητές για αυτόν τον πίνακα.',
  dashboard_variable_value_count: '{{count}} τιμή',
  dashboard_empty_value: 'Κενό',
  dashboard_open_variable_actions: 'Άνοιγμα {{name}} actions',
  dashboard_variable_delete_confirmation_prefix: 'Αυτό θα διαγράψει οριστικά τη μεταβλητή',
  dashboard_no_data_available: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
  dashboard_widget_failed_to_load_data: 'Αποτυχία φόρτωσης δεδομένων',
  dashboard_click_to_retry: 'Κάντε κλικ για επανάληψη',
  dashboard_chart_sampled_points_tooltip:
    'Εμφανίζεται δείγμα πραγματικών σημείων. Κάντε μεγέθυνση για να δείτε τα παραλειφθέντα σημεία.',
  dashboard_chart_all_points_tooltip: 'Εμφανίζονται όλα τα σημεία της τρέχουσας προβολής.',
  dashboard_widget_no_areas: 'Αυτό το widget δεν έχει περιοχές για εμφάνιση.',
  dashboard_widget_no_bars: 'Αυτό το widget δεν έχει ράβδους για εμφάνιση.',
  dashboard_widget_no_points: 'Αυτό το widget δεν έχει σημεία για σχεδίαση.',
  dashboard_widget_no_slices: 'Αυτό το widget δεν έχει τμήματα για εμφάνιση.',
  dashboard_widget_too_many_slices: 'Πάρα πολλά τμήματα για εμφάνιση',
  dashboard_widget_too_many_slices_description:
    'Αυτό το widget έχει {{slices}} τμήματα. Η σχεδίαση όλων θα κάνει τον πίνακα αργό στη φόρτωση και στη χρήση, και το γράφημα δυσανάγνωστο.',
  dashboard_widget_render_anyway: 'Εμφάνιση ούτως ή άλλως',
  dashboard_table_settings_missing: 'Λείπουν οι ρυθμίσεις πίνακα.',
  dashboard_widget_no_rows: 'Αυτό το widget δεν έχει γραμμές για εμφάνιση.',
  dashboard_gauge_settings_missing: 'Λείπουν οι ρυθμίσεις μετρητή.',
  dashboard_value_settings_missing: 'Λείπουν οι ρυθμίσεις της τιμής.',
  dashboard_widget_no_value: 'Αυτό το widget δεν έχει τιμή για εμφάνιση.',
  dashboard_widget_no_numeric_value: 'Αυτό το widget δεν έχει αριθμητική τιμή για εμφάνιση.',
  dashboard_timestamp: 'Χρονική σήμανση',
  dashboard_alarm_type: 'Τύπος συναγερμού',
  dashboard_alarm_count: 'Πλήθος συναγερμών',
  dashboard_level: 'Επίπεδο',
  dashboard_series_index: 'Σειρά {{index}}',
  dashboard_gauge_normal: 'Κανονικό',
  dashboard_gauge_threshold: 'Όριο',
  dashboard_start_named_guide: 'Έναρξη {{title}} οδηγός',
  dashboard_expand_named: 'Ανάπτυξη {{title}}',
  dashboard_expand_named_widget: 'Ανάπτυξη widget {{title}}',
  dashboard_close_named: 'Κλείσιμο {{title}}',
  dashboard_close_named_widget: 'Κλείσιμο {{title}} widget',
  dashboard_close_expanded_named_widget: 'Κλείσιμο ανεπτυγμένου widget {{title}}',
  dashboard_tour_header_dashboards: 'Βοήθεια: κεφαλίδα πίνακες.',
  dashboard_tour_header_settings: 'Βοήθεια: κεφαλίδα ρυθμίσεις.',
  dashboard_tour_header_title: 'Βοήθεια: κεφαλίδα τίτλος.',
  dashboard_tour_header_period: 'Βοήθεια: κεφαλίδα περίοδος.',
  dashboard_tour_header_layout: 'Βοήθεια: κεφαλίδα διάταξη.',
  dashboard_tour_header_add_widget: 'Βοήθεια: κεφαλίδα προσθήκη widget.',
  dashboard_tour_header_variables: 'Βοήθεια: κεφαλίδα μεταβλητές.',
  dashboard_tour_header_toggle_app_header: 'Βοήθεια: κεφαλίδα εναλλαγή εφαρμογή κεφαλίδα.',
  dashboard_tour_dashboard_canvas: 'Βοήθεια: πίνακας χώρος εργασίας.',
  dashboard_tour_selection_search: 'Βοήθεια: επιλογή αναζήτηση.',
  dashboard_tour_selection_add: 'Βοήθεια: επιλογή προσθήκη.',
  dashboard_tour_selection_list: 'Βοήθεια: επιλογή λίστα.',
  dashboard_tour_selection_favorite: 'Βοήθεια: επιλογή αγαπημένο.',
  dashboard_tour_selection_default: 'Βοήθεια: επιλογή προεπιλογή.',
  dashboard_tour_selection_all: 'Βοήθεια: επιλογή όλοι.',
  dashboard_tour_widget_title: 'Βοήθεια: widget τίτλος.',
  dashboard_tour_widget_type: 'Βοήθεια: widget τύπος.',
  dashboard_tour_widget_data_source: 'Βοήθεια: widget δεδομένα πηγή.',
  dashboard_tour_query_single_device: 'Βοήθεια: ερώτημα μονό συσκευή.',
  dashboard_tour_query_single_sensor: 'Βοήθεια: ερώτημα μονό αισθητήρας.',
  dashboard_tour_query_specific_devices: 'Βοήθεια: ερώτημα συγκεκριμένα συσκευές.',
  dashboard_tour_query_battery_range: 'Βοήθεια: ερώτημα μπαταρία εύρος.',
  dashboard_tour_query_device_groups: 'Βοήθεια: ερώτημα συσκευή ομάδες.',
  dashboard_tour_query_device_sensor_list: 'Βοήθεια: ερώτημα συσκευή αισθητήρας λίστα.',
  dashboard_tour_query_device_sensor_device: 'Βοήθεια: ερώτημα συσκευή αισθητήρας συσκευή.',
  dashboard_tour_query_device_sensor_sensor: 'Βοήθεια: ερώτημα συσκευή αισθητήρας αισθητήρας.',
  dashboard_tour_query_device_sensor_add: 'Βοήθεια: ερώτημα συσκευή αισθητήρας προσθήκη.',
  dashboard_tour_query_device_type_list: 'Βοήθεια: ερώτημα συσκευή τύπος λίστα.',
  dashboard_tour_query_device_type_devices: 'Βοήθεια: ερώτημα συσκευή τύπος συσκευές.',
  dashboard_tour_query_device_type_sensor_type: 'Βοήθεια: ερώτημα συσκευή τύπος αισθητήρας τύπος.',
  dashboard_tour_query_device_type_add: 'Βοήθεια: ερώτημα συσκευή τύπος προσθήκη.',
  dashboard_tour_query_prefer_flow: 'Βοήθεια: ερώτημα προτίμηση ροή.',
  dashboard_tour_query_timespan_mode: 'Βοήθεια: ερώτημα χρονικό διάστημα λειτουργία.',
  dashboard_tour_query_timespan_preset: 'Βοήθεια: ερώτημα χρονικό διάστημα προεπιλογή.',
  dashboard_tour_query_timespan_custom: 'Βοήθεια: ερώτημα χρονικό διάστημα προσαρμοσμένο.',
  dashboard_tour_widget_actions: 'Βοήθεια: widget ενέργειες.',
  dashboard_tour_widget_delete: 'Βοήθεια: widget διαγραφή.',
  dashboard_tour_dashboard_name: 'Βοήθεια: πίνακας όνομα.',
  dashboard_tour_dashboard_period: 'Βοήθεια: πίνακας περίοδος.',
  dashboard_tour_dashboard_timespan_mode: 'Βοήθεια: πίνακας χρονικό διάστημα λειτουργία.',
  dashboard_tour_dashboard_timespan_preset: 'Βοήθεια: πίνακας χρονικό διάστημα προεπιλογή.',
  dashboard_tour_dashboard_timespan_custom: 'Βοήθεια: πίνακας χρονικό διάστημα προσαρμοσμένο.',
  dashboard_tour_variable_add: 'Βοήθεια: μεταβλητή προσθήκη.',
  dashboard_tour_variable_row: 'Βοήθεια: μεταβλητή γραμμή.',
  dashboard_tour_variable_actions: 'Βοήθεια: μεταβλητή ενέργειες.',
  dashboard_tour_variable_name_label: 'Βοήθεια: μεταβλητή όνομα ετικέτα.',
  dashboard_tour_variable_type: 'Βοήθεια: μεταβλητή τύπος.',
  dashboard_tour_variable_source: 'Βοήθεια: μεταβλητή πηγή.',
  dashboard_tour_variable_value: 'Βοήθεια: μεταβλητή τιμή.',
  dashboard_tour_variable_actions_form: 'Βοήθεια: μεταβλητή ενέργειες φόρμα.',
  dashboard_dialog_currently_open: 'Το παράθυρο διαλόγου είναι ανοιχτό.',
};

export default i18n_gr;
